import React, { useState, useEffect, useContext, useMemo } from "react";
import { AuthContext } from "../../../contexts/AuthContext";
import Header from "../../../layout/Header/Header";
// import Footer from "../../layout/Footer/Footer";
import {
  Button,
  Row,
  Table,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Input,
  Label,
  ButtonGroup,
  Col,
  Spinner
} from "reactstrap";
import SweetAlert from "sweetalert2-react";
import Swal from "sweetalert2";
import { jsPDF } from "jspdf";
import "jspdf-autotable";
import autoTable from "jspdf-autotable";
import ExportJsonExcel from "js-export-excel";
import { encode } from "base64-arraybuffer";
import axios from "axios";
import Baja from "../../Baja";
import { TableHeader, Pagination, Search } from "../../../DataTable";
import useFullPageLoader from "../../../hooks/useFullPageLoader";
import qrcode from "qrcode-js";
import { v4 as uuidv4 } from "uuid";
import moment from "moment";

function ListadoVentas() {
  const { user } = useContext(AuthContext);
  const URL_SURTIDOS = process.env.REACT_APP_URL_SURTIDOS;
  const URL_CLIENTES = process.env.REACT_APP_URL_CLIENTES;
  const URL_COLABORADORES = process.env.REACT_APP_URL_COLABORADORES;
  const URL_SEND_MAIL_ATT = process.env.REACT_APP_URL_SEND_MAIL_ATT;
  const URL_SEND_MAIL_ATT_DOBLE = process.env.REACT_APP_URL_SEND_MAIL_ATT_DOBLE;
  const URL_ARTICULOS_SURTIDOS = process.env.REACT_APP_URL_ARTICULOS_SURTIDOS;
  const URL_DEPARTAMENTOS_CLIENTES =
    process.env.REACT_APP_URL_DEPARTAMENTOS_CLIENTES;
  const URL_UPMEDIA = process.env.REACT_APP_URL_UPMEDIA;
  const URL_WHATSAPP = process.env.REACT_APP_URL_WHATSAPP;
  const URL_EMPRESAS = process.env.REACT_APP_URL_EMPRESAS;
  const URL_LOGS = process.env.REACT_APP_URL_LOGS;
  const URL_ABONOS = process.env.REACT_APP_URL_ABONOS;
  const URL_BANCOS = process.env.REACT_APP_URL_BANCOS;
  const URL_MOVIMIENTOS_BANCOS = process.env.REACT_APP_URL_MOVIMIENTOS_BANCOS;
  const URL_FACTURAS = process.env.REACT_APP_URL_FACTURAS;
  const URL_SERIES = process.env.REACT_APP_URL_SERIES;
  const URL_TIMBRAR = process.env.REACT_APP_URL_TIMBRAR;

  let hoy = new Date();
  let inicio = new Date();
  inicio.setDate(inicio.getDate() - 30);
  let fechaPago = moment(hoy).format("YYYY-MM-DD");

  let endDate = moment(hoy).format("YYYY-MM-DD");
  let startDate = moment(inicio).format("YYYY-MM-DD");

  let comp5 = new Date();
  comp5.setDate(comp5.getDate() - 5);
  let evidencia5 = moment(comp5).format("YYYY-MM-DD");

  const [clientes, setClientes] = useState([]);
  const [selectedCliente, setSelectedCliente] = useState("");
  const [colaboradores, setColaboradores] = useState([]);
  const [selectedColaborador, setSelectedColaborador] = useState("");
  const [selectedUser, setSelectedUser] = useState("");
  const [selectedActivo, setSelectedActivo] = useState("");
  const [selectedEntregado, setSelectedEntregado] = useState("");

  const [selectedFechaInicio, setSelectedFechaInicio] = useState(startDate);
  const [selectedFechaFin, setSelectedFechaFin] = useState(endDate);

  const [empresas, setEmpresas] = useState([]);
  const [selectedEmpresa, setSelectedEmpresa] = useState("");
  const [selectedMetodo, setSelectedMetodo] = useState("");
  const [departamentos, setDepartamentos] = useState([]);
  const [selectedDepartamento, setSelectedDepartamento] = useState("");

  const [modalMail, setModalMail] = useState(false);
  const toggleMail = () => setModalMail(!modalMail);
  const [mailTo, setMailTo] = useState("");

  // Facturar Preview
  const [modalFacturarPreview, setModalFacturarPreview] = useState(false);
  const toggleFacturarPreview = () => setModalFacturarPreview(!modalFacturarPreview);
  const [facturarSurtido, setFacturarSurtido] = useState(null);
  const [facturarArticulos, setFacturarArticulos] = useState([]);
  const [facturarCliente, setFacturarCliente] = useState(null);
  const [facturarEmpresa, setFacturarEmpresa] = useState(null);
  const [facturarSeries, setFacturarSeries] = useState([]);
  const [facturarSerie, setFacturarSerie] = useState("");
  const [facturarTimbres, setFacturarTimbres] = useState(0);
  const [facturando, setFacturando] = useState(false);

  const [activo, setActivo] = useState("");
  const [subTotalImporteTabla, setSubTotalImporteTabla] = useState(0);
  const [totalImporteTabla, setTotalImporteTabla] = useState(0);
  const [totalPiezasTabla, setTotalPiezasTabla] = useState(0);

   const [selectedSaldo, setSelectedSaldo] = useState("");
   const [selectedSolicitarFactura, setSelectedSolicitarFactura] = useState("");
   const [selectedFacturaHecha, setSelectedFacturaHecha] = useState("");
   const [selectedNotasEntrega, setSelectedNotasEntrega] = useState([]);

  const [idEvidencia, setidEvidencia] = useState("");
  const [noFactura, setNoFactura] = useState("");
  const [noGuia, setNoGuia] = useState("");
  const [fileFotoEvidencia, setFileFotoEvidencia] = useState();
  const [fileFotoEvidencia2, setFileFotoEvidencia2] = useState();
  const [fotoEvidencia2, setFotoEvidencia2] = useState("No");
  const [fotoEvidencia, setFotoEvidencia] = useState("No");

  const [modalEvidencia, setModalEvidencia] = useState(false);
  const toggleEvidencia = () => setModalEvidencia(!modalEvidencia);
  const [photoEvidencia, setPhotoEvidencia] = useState([]);
  const [modalVerFotoEvidencia, setModalVerFotoEvidencia] = useState(false);
  const toggleVerFotoEvidencia = () =>
    setModalVerFotoEvidencia(!modalVerFotoEvidencia);

  const [enviarMail, setEnviarMail] = useState("");
  const [fechaMail, setFechaMail] = useState("");
  const [idClientesMail, setIdClientesMail] = useState("");
  const [clientesMail, setClientesMail] = useState("");
  const [observacionesMail, setObservacionesMail] = useState("");
  const [numeroMail, setNumeroMail] = useState("");
  const [idPDFOCMail, setIdPDFOCMail] = useState("");
  const [userMail, setUserMail] = useState("");
  const [pedidosMail, setPedidosMail] = useState("");
  const [comisionTDCMail, setComisionTDCMail] = useState("");
  const [comisionFleteMail, setComisionFleteMail] = useState("");
  const [impuestosMail, setImpuestosMail] = useState("");
  const [subTotalMail, setSubTotalMail] = useState("");
  const [ivaMail, setIvaMail] = useState("");
  const [total_generalMail, setTotal_generalMail] = useState("");
  const [calleMail, setCalleMail] = useState("");
  const [numero_extMail, setNumero_extMail] = useState("");
  const [numero_intMail, setNumero_intMail] = useState("");
  const [paisMail, setPaisMail] = useState("");
  const [estadoMail, setEstadoMail] = useState("");
  const [ciudadMail, setCiudadMail] = useState("");
  const [delegacionMail, setDelegacionMail] = useState("");
  const [coloniaMail, setColoniaMail] = useState("");
  const [cpMail, setCpMail] = useState("");
  const [rFCMail, setRFCMail] = useState("");
  const [paqueteriaMail, setPaqueteriaMail] = useState("");
  const [areaMail, setAreaMail] = useState("");
  const [codigoClientesMail, setCodigoClientesMail] = useState("");
  const [vendedorMail, setVendedorMail] = useState("");
  const [telefonoMail, setTelefonoMail] = useState("");
  const [plazoMail, setPlazoMail] = useState("");

  const [idEdit, setIdEdit] = useState("");
  const [clienteEdit, setClienteEdit] = useState("");
  const [idClienteEdit, setIdClienteEdit] = useState("");
  const [idColaboradorEdit, setIdColaboradorEdit] = useState("");
  const [numeroEdit, setNumeroEdit] = useState("");
  const [facturaEdit, setFacturaEdit] = useState("");
  const [modalEditNota, setModalEditNota] = useState(false);
  const toggleEditNota = () => setModalEditNota(!modalEditNota);

  const [modalPagarNota, setModalPagarNota] = useState(false);
  const togglePagarNota = () => setModalPagarNota(!modalPagarNota);
  const [fecha, setFecha] = useState(fechaPago);
  const [concepto, setConcepto] = useState("Abono");
  const [formaPago, setFormaPago] = useState("Transfer");
  const [selectedBanco, setSelectedBanco] = useState("");
  const [bancos, setBancos] = useState([]);
  const [moneda, setMoneda] = useState("");
  const [monto, setMonto] = useState(0);
  const [codigoAgrupado, setCodigoAgrupado] = useState(uuidv4());
  const [validaBoton, setValidaBoton] = useState(true);
  const [modalProgreso, setModalProgreso] = useState(false);
  const toggleProgreso = () => setModalProgreso(!modalProgreso);

  //--- Pagination
  const [comments, setComments] = useState([]);
  const [loader, showLoader, hideLoader] = useFullPageLoader();
  const [totalItems, setTotalItems] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [search, setSearch] = useState("");
  const [sorting, setSorting] = useState({ field: "", order: "" });

  const ITEMS_PER_PAGE = 50;

  useEffect(() => {
    axios
      .get(URL_CLIENTES, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allClientes = response.data;
        setClientes(allClientes);
      })
      .catch((err) => {
        console.log(err);
      });

    axios
      .get(URL_COLABORADORES, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allColaboradores = response.data;
        setColaboradores(allColaboradores);
      })
      .catch((err) => {
        console.log(err);
      });

    axios
      .get(URL_DEPARTAMENTOS_CLIENTES, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((res) => {
        const allDepartamentos = res.data;
        setDepartamentos(allDepartamentos);
      })
      .catch((err) => {
        console.log(err);
      });
      
      axios
      .get(URL_EMPRESAS, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((res) => {
        const allEmpresas = res.data;
        setEmpresas(allEmpresas);
      })
      .catch((err) => {
        console.log(err);
      })
      axios
      .get(URL_BANCOS, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allBancos = response.data;
        setBancos(allBancos);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  useEffect(() => {
  const headers = {
    Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
  };

  Promise.all([
    axios.get(`${URL_SURTIDOS}Fechas/${selectedFechaInicio}/${selectedFechaFin}`, {
      headers,
    }),
    axios.get(`${URL_ABONOS}`, { headers }), // ajusta si tu endpoint es diferente
  ])
    .then(([responseSurtidos, responseAbonos]) => {
      let allSurtidos = responseSurtidos.data;
      let allAbonos = responseAbonos.data || [];

      let arrayTabla = allSurtidos
        .sort((a, b) => (a.idSurtido < b.idSurtido ? 1 : -1))
        .map((a) => {
          const abonosSurtido = allAbonos.filter((abono) =>
            abono?.surtidos?.some(
              (s) =>
                String(typeof s === "object" ? s._id : s) === String(a._id)
            )
          );

          const formasPagoUnicas = [
            ...new Set(
              abonosSurtido
                .map((abono) => abono?.formaPago)
                .filter((fp) => fp && fp !== "NA")
            ),
          ];

          const bancosUnicos = [
            ...new Set(
              abonosSurtido
                .map((abono) => abono?.bancos?.[0]?.banco)
                .filter((b) => b && b !== "NA")
            ),
          ];

          const user0 = a.user?.[0] || {};
          const ped0 = a.pedidos?.[0] || {};
          const pedCli0 = ped0.clientes?.[0] || {};
          const pedCol0 = ped0.colaboradores?.[0] || {};
          const cli0 = a.clientes?.[0] || {};
          const dep0 = cli0.departamentosClientes?.[0] || {};
          const area0 = a.areas?.[0] || {};
          const emp0 = a.empresas?.[0] || {};
          const fac0 = a.facturas?.[0] || {};

          return {
            _id: a._id,
            is_active: a.is_active,
            fecha: a.fecha,
            user: `${user0.nombre || ""} ${user0.apellido || ""}`.trim(),
            idUser: user0._id || "",
            pedidos: ped0.idPedido || "",
            idPedido: ped0._id || "",
            clientes: pedCli0.nombre_comercial || cli0.nombre_comercial || "",
            codigoClientes: pedCli0.codigo || "",
            idClientes: pedCli0._id || cli0._id || "",
            observaciones: a.observaciones,
            numero: a.idSurtido,
            comisionTDC: ped0.comisionTDC || 0,
            comisionFlete: a.flete,
            comisionInstalacion: a.instalacion,
            impuestos: a.impuestos,
            impuestosLetra: a.impuestos == 16 ? "Si" : "No",
            descuento: a.descuento,
            subTotal: a.subTotal,
            iva: a.iva,
            total_general: a.total_general,
            calle: cli0.calle || "",
            numero_ext: cli0.numero_ext || "",
            numero_int: cli0.numero_int || "",
            pais: cli0.pais || "",
            estado: cli0.estado || "",
            ciudad: cli0.ciudad || "",
            delegacion: cli0.delegacion || "",
            colonia: cli0.colonia || "",
            cp: cli0.cp || "",
            paqueteria: cli0.paqueteria || "",
            RFC: cli0.RFC || "",
            area: area0.name || "",
            vendedor: `${pedCol0.nombre || ""} ${pedCol0.apellido || ""}`.trim(),
            idVendedor: pedCol0._id || "",
            telefono: cli0.telefono || "",
            idDepartamento: dep0._id || "",
            departamentoName: dep0.name || "",
            fotoEvidencia: a.fotoEvidencia,
            mail: a.mail,
            plazo: cli0.plazo || 0,
            total_cantidad: a.total_cantidad,
            noGuia: a.noGuia,
            noFactura: a.noFactura,
            facturado: a.facturado,
            solicitarFactura: a.solicitarFactura || "No",
            facturaHecha: a.facturaHecha || "No",
            correo: cli0.email || "",
            factura:
              a.facturado === "Si"
                ? `${fac0.serie || ""}${fac0.folio || ""}`
                : "NA",
            empresas: emp0.name || "",
            idEmpresa: emp0._id || "",
            flete: a.flete,
            saldo: a.is_active === "No" ? 0 : a.saldo,
            direccionEntrega: a.direccionEntrega,
            metodoEntrega: a.entregada === "Si" ? a.metodoEntrega : "",
            fechaEntrega: a.entregada === "Si" ? a.fechaEntrega : "",
            entregada: a.entregada,

            // NUEVOS CAMPOS
            tienePagos: abonosSurtido.length > 0 ? "Si" : "No",
            formaPago:
              abonosSurtido.length > 0
                ? formasPagoUnicas[0] || ""
                : "",
            formasPago:
              abonosSurtido.length > 0
                ? formasPagoUnicas.join(", ")
                : "",
            banco:
              abonosSurtido.length > 0 ? bancosUnicos.join(", ") : "",
            totalPagado: abonosSurtido.reduce(
              (acc, abono) => acc + (Number(abono.importe) || 0),
              0
            ),
          };
        })
        .filter((el) => el != null);

      setComments(Object.values(arrayTabla));
    })
    .catch((err) => {
      console.log(err);
    });
}, [selectedFechaInicio, selectedFechaFin]);

function PDFTabla() {
  let subTotalTotal = 0;
  let totalTotal = 0;
  let data1 = comments;

  if (selectedDepartamento) {
    data1 = data1.filter((e) =>
      e.idDepartamento.includes(selectedDepartamento)
    );
  }

  if (search) {
    data1 = data1.filter(
      (comment) =>
        comment.clientes.toLowerCase().includes(search.toLowerCase()) ||
        comment.area.toLowerCase().includes(search.toLowerCase()) ||
        comment.vendedor.toLowerCase().includes(search.toLowerCase()) ||
        comment.departamentoName.toLowerCase().includes(search.toLowerCase()) ||
        comment.metodoEntrega.toLowerCase().includes(search.toLowerCase()) ||
        comment.formaPago.toLowerCase().includes(search.toLowerCase()) ||
        comment.pedidos.toString().includes(search) ||
        comment.numero.toString().includes(search) ||
        comment.subTotal.toString().includes(search) ||
        comment.saldo.toString().includes(search) ||
        comment.total_general.toString().includes(search)
    );
  }

  // ✅ FILTRO DE SALDO PARA EL PDF
  if (selectedSaldo == "Si") {
    data1 = data1.filter((e) => Number(e.saldo) > 0);
  }

  if (selectedSaldo == "No") {
    data1 = data1.filter((e) => Number(e.saldo) === 0);
  }

  let data = data1.map((a) => {
    totalTotal = totalTotal + a.total_general;
    subTotalTotal = subTotalTotal + a.subTotal;

    if (
      (selectedFechaInicio == 0 || selectedFechaInicio <= a.fecha) &&
      (selectedFechaFin == 0 || selectedFechaFin >= a.fecha) &&
      (activo == 0 || activo == a.is_active) &&
      (selectedCliente == 0 || selectedCliente == a.idClientes) &&
      (selectedColaborador == 0 || selectedColaborador == a.idVendedor) &&
      (selectedEntregado == 0 || selectedEntregado == a.entregada) &&
      (selectedEmpresa == 0 || selectedEmpresa == a.idEmpresa) &&
      (selectedMetodo == 0 || selectedMetodo == a.metodoEntrega)
    ) {
      if (a.is_active == "Si") {
        return [
          a.numero,
          a.fecha,
          a.clientes,
          a.vendedor,
          a.metodoEntrega,
          a.fechaEntrega,
          new Intl.NumberFormat("en-US", {
            style: "currency",
            currency: "USD",
            maximumFractionDigits: 2,
          }).format(a.subTotal),
          new Intl.NumberFormat("en-US", {
            style: "currency",
            currency: "USD",
            maximumFractionDigits: 2,
          }).format(a.total_general),
          new Intl.NumberFormat("en-US", {
            style: "currency",
            currency: "USD",
            maximumFractionDigits: 2,
          }).format(a.saldo),
          new Intl.NumberFormat("en-US", {}).format(a.total_cantidad),
          a.factura,
          a.formaPago,
        ];
      } else {
        return [
          a.numero,
          a.fecha,
          a.clientes,
          a.vendedor,
          "",
          "",
          "",
          "CANCELADA",
          "",
          "",
          "",
          "",
        ];
      }
    }
  });

  const dataPDF = Object.values(data);
  const dataPDFLimpia = dataPDF.filter(function (el) {
    return el != null;
  });

  const doc = new jsPDF("landscape", "mm", "a4", true);
  var img = new Image();

  var img2 = new Image();
  img2.src = process.env.PUBLIC_URL + "logoInstitucion.png";
  doc.addImage(img2, "png", 120, 15, 40, 30);
  doc.text(`Listado de Notas`, 20, 30);
  doc.text(`${selectedFechaInicio} - ${selectedFechaFin}`, 20, 40);

  doc.autoTable({
    head: [
      [
        "Numero",
        "Fecha",
        "Cliente",
        "Vendedor",
        "Metodo Entrega",
        "Fecha Entrega",
        "SubTotal",
        "Importe",
        "Saldo",
        "Piezas",
        "Factura",
        "Forma Pago",
      ],
    ],
    body: dataPDFLimpia,
    headStyles: {
      fillColor: ["#00313c"],
      lineWidth: 0,
    },
    footStyles: {
      fillColor: ["#00313c"],
    },
    theme: "grid",
    startY: 50,
    foot: [
      [
        "",
        "",
        "",
        "",
        "",
        "Total",
        new Intl.NumberFormat("en-US", {
          style: "currency",
          currency: "USD",
          maximumFractionDigits: 2,
        }).format(subTotalImporteTabla),
        new Intl.NumberFormat("en-US", {
          style: "currency",
          currency: "USD",
          maximumFractionDigits: 2,
        }).format(totalImporteTabla),
        "",
        new Intl.NumberFormat("en-US", {}).format(totalPiezasTabla),
      ],
    ],
    showFoot: "lastPage",
  });

  doc.save(`Notas.pdf`);
}

  function excel() {
    let data1 = comments;
    if (selectedDepartamento) {
      data1 = data1.filter((e) =>
        e.idDepartamento.includes(selectedDepartamento)
      );
    }
    if (search) {
      data1 = data1.filter(
        (comment) =>
          comment.clientes.toLowerCase().includes(search.toLowerCase()) ||
          comment.area.toLowerCase().includes(search.toLowerCase()) ||
          comment.vendedor.toLowerCase().includes(search.toLowerCase()) ||
          comment.departamentoName.toLowerCase().includes(search.toLowerCase()) ||
          comment.metodoEntrega.toLowerCase().includes(search.toLowerCase()) ||
          comment.formaPago.toLowerCase().includes(search.toLowerCase()) ||
          comment.pedidos.toString().includes(search) ||
          comment.numero.toString().includes(search) ||
          comment.subTotal.toString().includes(search) ||
          comment.total_general.toString().includes(search)
      );
    }
    // Formato del ejemplo REG DE VENTAS (columnas: Nombre, Agente, Fecha,
    // Modelo/Nota, Total, IVA, Gran Total, Pagado, Saldo/FG, Factura, Extras,
    // M Pago, CUENTA, NOTAS, Comision, PORCENTAJE, C P, Telefono, Correo,
    // TDC, Monto total facturación, Comentarios fac, Almacen, Cancelada)
    const dataExcel = data1.map((a) => {
      if (
        (selectedFechaInicio == 0 || selectedFechaInicio <= a.fecha) &&
        (selectedFechaFin == 0 || selectedFechaFin >= a.fecha) &&
        (activo == 0 || activo == a.is_active) &&
        (selectedCliente == 0 || selectedCliente == a.idClientes) &&
        (selectedColaborador == 0 || selectedColaborador == a.idVendedor) &&
        (selectedEntregado == 0 || selectedEntregado == a.entregada) &&
        (selectedEmpresa == 0 || selectedEmpresa == a.idEmpresa) &&
        (selectedMetodo == 0 || selectedMetodo == a.metodoEntrega)
      ) {
        const extras =
          (Number(a.flete) || 0) + (Number(a.comisionInstalacion) || 0);
        const isTDC = a.formaPago === "TDC" || a.formaPago === "TDD";
        const cancelada = a.is_active === "No";
        return {
          Nombre: a.clientes,
          Agente: a.vendedor,
          Fecha: a.fecha,
          "Modelo/Nota": a.numero,
          Total: cancelada ? 0 : a.subTotal,
          IVA: cancelada ? 0 : a.iva,
          "Gran Total": cancelada ? 0 : a.total_general,
          Pagado: cancelada ? 0 : (a.totalPagado || 0),
          "Saldo/FG": cancelada ? 0 : a.saldo,
          Factura: a.factura || "",
          Extras: extras,
          "M Pago": a.formaPago || "",
          CUENTA: a.banco || "",
          NOTAS: a.observaciones || "",
          Comision: "",
          PORCENTAJE: "",
          "C P": a.cp || "",
          Telefono: a.telefono || "",
          Correo: a.correo || "",
          TDC: isTDC ? "Si" : "No",
          "Monto total facturación":
            a.facturado === "Si" ? a.total_general : 0,
          "Comentarios fac": a.facturaHecha === "Si" ? "Factura hecha" : "",
          Almacen: a.area || "",
          Cancelada: cancelada ? "SI" : "NO",
        };
      }
    });
    const dataExportExcel = Object.values(dataExcel);
    const dataExcelLimpia = dataExportExcel.filter((el) => el != null);

    const columnas = [
      "Nombre",
      "Agente",
      "Fecha",
      "Modelo/Nota",
      "Total",
      "IVA",
      "Gran Total",
      "Pagado",
      "Saldo/FG",
      "Factura",
      "Extras",
      "M Pago",
      "CUENTA",
      "NOTAS",
      "Comision",
      "PORCENTAJE",
      "C P",
      "Telefono",
      "Correo",
      "TDC",
      "Monto total facturación",
      "Comentarios fac",
      "Almacen",
      "Cancelada",
    ];

    const option = {
      fileName: "RegistroDeVentas",
      datas: [
        {
          sheetData: dataExcelLimpia,
          sheetName: "Registro de Ventas",
          sheetFilter: columnas,
          sheetHeader: columnas,
        },
      ],
    };

    const toExcel = new ExportJsonExcel(option);
    toExcel.saveExcel();
  }

  function enviaMail() {
    let subTotalTotal = 0;
    let totalTotal = 0;
    let data1 = comments;
    if (selectedDepartamento) {
      data1 = data1.filter((e) =>
        e.idDepartamento.includes(selectedDepartamento)
      );
    }
    if (search) {
      data1 = data1.filter(
        (comment) =>
          comment.clientes.toLowerCase().includes(search.toLowerCase()) ||
          comment.area.toLowerCase().includes(search.toLowerCase()) ||
          comment.vendedor.toLowerCase().includes(search.toLowerCase()) ||
          comment.departamentoName.toLowerCase().includes(search.toLowerCase()) ||
          comment.metodoEntrega.toLowerCase().includes(search.toLowerCase()) ||
          comment.pedidos.toString().includes(search) ||
          comment.numero.toString().includes(search) ||
          comment.subTotal.toString().includes(search) ||
          comment.total_general.toString().includes(search)
      );
    }
    let data = data1.map((a) => {
      totalTotal = totalTotal + a.total_general;
      subTotalTotal = subTotalTotal + a.subTotal;
      if (
        (selectedFechaInicio == 0 || selectedFechaInicio <= a.fecha) &&
        (selectedFechaFin == 0 || selectedFechaFin >= a.fecha) &&
        (activo == 0 || activo == a.is_active) &&
        (selectedCliente == 0 || selectedCliente == a.idClientes) &&
        (selectedColaborador == 0 || selectedColaborador == a.idVendedor) &&
        (selectedEntregado == 0 || selectedEntregado == a.entregada) &&
        (selectedEmpresa == 0 || selectedEmpresa == a.idEmpresa)&&
        (selectedMetodo == 0 || selectedMetodo == a.metodoEntrega)
      ) {
        if (a.is_active == "Si") {
          return [
            a.numero,
            a.fecha,
            a.clientes,
            a.departamentoName,
            a.vendedor,
            new Intl.NumberFormat("en-US", {
              style: "currency",
              currency: "USD",
              maximumFractionDigits: 2,
            }).format(a.subTotal),
            new Intl.NumberFormat("en-US", {
              style: "currency",
              currency: "USD",
              maximumFractionDigits: 2,
            }).format(a.total_general),
          ];
        } else {
          return [
            a.numero,
            a.fecha,
            a.clientes,
            a.departamentoName,
            a.vendedor,
            "CANCELADA",
            0,
          ];
        }
      }
    });
    const dataPDF = Object.values(data);
    const dataPDFLimpia = dataPDF.filter(function (el) {
      return el != null;
    });
    const doc = new jsPDF({ compressPdf: true });
    var img = new Image();

    var img2 = new Image();
    img2.src = process.env.PUBLIC_URL + "logoInstitucion.png";
    doc.addImage(img2, "png", 150, 25, 35, 15);
    doc.text(`Listado de Notas`, 20, 30);
    doc.text(`${selectedFechaInicio} - ${selectedFechaFin}`, 20, 40);
    doc.autoTable({
      head: [
        [
          "Numero",
          "Fecha",
          "Cliente",
          "Departamento",
          "Vendedor",
          "SubTotal",
          "Importe",
        ],
      ],
      body: dataPDFLimpia,
      headStyles: {
        fillColor: ["#00313c"],
        lineWidth: 0,
      },
      footStyles: {
        fillColor: ["#00313c"],
      },
      theme: "grid",
      startY: 50,
      foot: [
        [
          "",
          "",
          "",
          "",
          "Total",
          new Intl.NumberFormat("en-US", {
            style: "currency",
            currency: "USD",
            maximumFractionDigits: 2,
          }).format(subTotalTotal),
          new Intl.NumberFormat("en-US", {
            style: "currency",
            currency: "USD",
            maximumFractionDigits: 2,
          }).format(totalTotal),
        ],
      ],
      showFoot: "lastPage",
    });
    var att = doc.output("arraybuffer");
    var base64File = encode(att);

    // Envia el Mail
    axios
      .post(
        URL_SEND_MAIL_ATT,
        {
          subject: "Listado de Notas",
          email: mailTo,
          fileName: "ListadoNotas.pdf",
          att: base64File,
          text: `<table border="0" cellpadding="0" cellspacing="0" width="100%">
         <th><img width="${process.env.REACT_APP_TAMANO_LOGO_MAIL}" align="center" src="${process.env.REACT_APP_LINK_SISTEMA}logoInstitucion.png" /></th>
         <tr align="center" style="font-size:30px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px;font-weight:bold"><br>${process.env.REACT_APP_NOMBRE_INSTITUCION}</tr>
         <tbody>
         <tr style="font-size:20px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px;font-weight:bold"><br>Hola,</tr>
         <tr style="font-size:20px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px;font-weight:bold"><br>Adjunto encontraras el listado de Notas.</tr>
         </tbody>
         <tr style="font-size:16px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px"><br>Favor de no responder este correo, para cualquier duda favor de comunicarse al ${process.env.REACT_APP_TELEFONO_INSTITUCION}</tr>
         
         </table>`,
        },
        {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          },
        }
      )
      .then(() => {
        toggleMail();
        Swal.fire("Good job!", "Enviado con exito", "success");
      })
      .catch((error) => {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong!",
          footer: `${error.response.data}`,
        });
        console.log(error);
      });
  }

function cancelarNota(idNota, numero) {
  Swal.fire({
    title: "¿Estás seguro?",
    text: "¡Se cancelará la Nota!",
    icon: "warning",
    showCancelButton: true,
    confirmButtonColor: "#3085d6",
    cancelButtonColor: "#d33",
    confirmButtonText: "Sí, Cancelar!",
  }).then((result) => {
    if (result.isConfirmed) {
      axios
        .get(`${URL_SURTIDOS}Cancel/${idNota}`, {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          },
        })
        .then(() => {
          // 🔹 Registrar log de cancelación
          axios.post(
            URL_LOGS,
            {
              tipo: "Cancelar Nota",
              detalle: `Nota ${numero} cancelada`,
              user: user.id,
            },
            {
              headers: {
                Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
              },
            }
          );

          setComments((prev) =>
            prev.map((c) =>
              c._id === idNota ? { ...c, is_active: "No", saldo: 0 } : c
            )
          );
          Swal.fire("Good job!", "Nota cancelada con éxito", "success");
        })
        .catch((error) => {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: "Algo salió mal!",
            footer: `${error.response?.data || "Error desconocido"}`,
          });
          console.log(error);
        });
    }
  });
}

function toggleSelectNota(id) {
  setSelectedNotasEntrega((prev) =>
    prev.includes(id) ? prev.filter((x) => x !== id) : [...prev, id]
  );
}

function entregarNotasSeleccionadas() {
  if (selectedNotasEntrega.length === 0) {
    Swal.fire({ icon: "warning", title: "Sin selección", text: "Selecciona al menos una nota." });
    return;
  }
  Swal.fire({
    title: `Entregar ${selectedNotasEntrega.length} nota(s)`,
    icon: "warning",
    html: `
      <div style="text-align:left">
        <label>Método de Entrega</label>
        <select id="metodoEntregaBulk" class="swal2-select">
          <option value="">Selecciona</option>
          <option value="Flete Roberto">Flete Roberto</option>
          <option value="Flete Omar">Flete Omar</option>
          <option value="Flete Edward">Flete Edward</option>
          <option value="Flete Lalamove">Flete Lalamove</option>
          <option value="Flete Otro">Flete Otro</option>
          <option value="Paqueteria Paquetexpress">Paqueteria Paquetexpress</option>
          <option value="Paqueteria Almex">Paqueteria Almex</option>
          <option value="Paqueteria Tresguerras">Paqueteria Tresguerras</option>
          <option value="Paqueteria FedEx">Paqueteria FedEx</option>
          <option value="Paqueteria DHL">Paqueteria DHL</option>
          <option value="Paqueteria Castores">Paqueteria Castores</option>
          <option value="Cliente Recoge">Cliente Recoge</option>
        </select>

        <label style="margin-top:10px">Fecha de Entrega</label>
        <input type="date" id="fechaEntregaBulk" class="swal2-input">
      </div>
    `,
    showCancelButton: true,
    confirmButtonText: "Sí, Entregar todas",
    cancelButtonText: "Cancelar",
    confirmButtonColor: "#3085d6",
    cancelButtonColor: "#d33",
    preConfirm: () => {
      const metodoEntrega = document.getElementById("metodoEntregaBulk").value;
      const fechaEntrega = document.getElementById("fechaEntregaBulk").value;
      if (!metodoEntrega) {
        Swal.showValidationMessage("Debes seleccionar el método de entrega");
        return false;
      }
      if (!fechaEntrega) {
        Swal.showValidationMessage("Debes seleccionar la fecha de entrega");
        return false;
      }
      return { metodoEntrega, fechaEntrega };
    },
  }).then(async (result) => {
    if (!result.isConfirmed) return;
    const { metodoEntrega, fechaEntrega } = result.value;
    const ids = [...selectedNotasEntrega];
    const headers = { Authorization: `Bearer: ${localStorage.getItem("app_token")}` };
    const errores = [];
    await Promise.all(
      ids.map(async (idNota) => {
        try {
          await axios.patch(
            `${URL_SURTIDOS}/${idNota}`,
            { entregada: "Si", metodoEntrega, fechaEntrega },
            { headers }
          );
          const c = comments.find((x) => x._id === idNota);
          axios.post(
            URL_LOGS,
            {
              tipo: "Entregar Nota",
              detalle: `Nota ${c?.numero || idNota} entregada / Método: ${metodoEntrega} / Fecha: ${fechaEntrega}`,
              user: user.id,
            },
            { headers }
          );
        } catch (err) {
          errores.push(idNota);
          console.log(err);
        }
      })
    );

    const setIds = new Set(ids.filter((id) => !errores.includes(id)));
    setComments((prev) =>
      prev.map((c) =>
        setIds.has(c._id)
          ? { ...c, entregada: "Si", metodoEntrega, fechaEntrega }
          : c
      )
    );
    setSelectedNotasEntrega([]);

    if (errores.length === 0) {
      Swal.fire("Correcto", `${ids.length} nota(s) entregadas`, "success");
    } else {
      Swal.fire({
        icon: "warning",
        title: "Con errores",
        text: `Se entregaron ${ids.length - errores.length} de ${ids.length}. ${errores.length} fallaron.`,
      });
    }
  });
}

function entregarNota(idNota, numero) {
  Swal.fire({
    title: "Entregar Nota",
    icon: "warning",
    html: `
      <div style="text-align:left">
        <label>Método de Entrega</label>
        <select id="metodoEntrega" class="swal2-select">
          <option value="">Selecciona</option>
          <option value="Flete Roberto">Flete Roberto</option>
          <option value="Flete Omar">Flete Omar</option>
          <option value="Flete Edward">Flete Edward</option>
          <option value="Flete Lalamove">Flete Lalamove</option>
          <option value="Flete Otro">Flete Otro</option>
          <option value="Paqueteria Paquetexpress">Paqueteria Paquetexpress</option>
          <option value="Paqueteria Almex">Paqueteria Almex</option>
          <option value="Paqueteria Tresguerras">Paqueteria Tresguerras</option>
          <option value="Paqueteria FedEx">Paqueteria FedEx</option>
          <option value="Paqueteria DHL">Paqueteria DHL</option>
          <option value="Paqueteria Castores">Paqueteria Castores</option>
          <option value="Cliente Recoge">Cliente Recoge</option>
        </select>

        <label style="margin-top:10px">Fecha de Entrega</label>
        <input type="date" id="fechaEntrega" class="swal2-input">
      </div>
    `,
    showCancelButton: true,
    confirmButtonText: "Sí, Entregar",
    cancelButtonText: "Cancelar",
    confirmButtonColor: "#3085d6",
    cancelButtonColor: "#d33",
    preConfirm: () => {
      const metodoEntrega = document.getElementById("metodoEntrega").value;
      const fechaEntrega = document.getElementById("fechaEntrega").value;

      if (!metodoEntrega) {
        Swal.showValidationMessage("Debes seleccionar el método de entrega");
        return false;
      }

      if (!fechaEntrega) {
        Swal.showValidationMessage("Debes seleccionar la fecha de entrega");
        return false;
      }

      return { metodoEntrega, fechaEntrega };
    },
  }).then((result) => {
    if (result.isConfirmed) {
      const { metodoEntrega, fechaEntrega } = result.value;

      axios
        .patch(
          `${URL_SURTIDOS}/${idNota}`,
          {
            entregada: "Si",
            metodoEntrega,
            fechaEntrega,
          },
          {
            headers: {
              Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
            },
          }
        )
        .then(() => {
          axios.post(
            URL_LOGS,
            {
              tipo: "Entregar Nota",
              detalle: `Nota ${numero} entregada / Método: ${metodoEntrega} / Fecha: ${fechaEntrega}`,
              user: user.id,
            },
            {
              headers: {
                Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
              },
            }
          );

          setComments((prev) =>
            prev.map((c) =>
              c._id === idNota
                ? { ...c, entregada: "Si", metodoEntrega, fechaEntrega }
                : c
            )
          );
          Swal.fire("Correcto", "Nota entregada con éxito", "success");
        })
        .catch((error) => {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: "Algo salió mal!",
            footer: `${error.response?.data || "Error desconocido"}`,
          });
          console.log(error);
        });
    }
  });
}

  function jalaBanco(e) {
    setSelectedBanco(e);
    bancos.map((a) => {
      if (a._id == e) {
        return setMoneda(a.moneda);
      }
    });
  }


  async function savePagarNota() {
  setValidaBoton(false);


  if (
    fecha === "" ||
    formaPago === "" ||
    concepto === "" ||
    selectedBanco === ""
  ) {
    Swal.fire({
      icon: "error",
      title: "Oops...",
      text: "Debes completar todo el formulario",
    });
    setValidaBoton(true);
    return;
  }

  if (!monto || monto <= 0) {
    Swal.fire({
      icon: "error",
      title: "Oops...",
      text: "Debes capturar un importe válido",
    });
    setValidaBoton(true);
    return;
  }

  Swal.fire({
    title: "Estas seguro?",
    text: "Se registrará el abono",
    icon: "warning",
    showCancelButton: true,
    confirmButtonColor: "#3085d6",
    cancelButtonColor: "#d33",
    confirmButtonText: "Si, Enviar!",
  }).then(async (result) => {
    if (!result.isConfirmed) {
      setValidaBoton(true);
      return;
    }

    try {
      toggleProgreso();

      const dataAbono = await axios.post(
        URL_ABONOS,
        {
          fecha,
          importe: monto,
          clientes: idClienteEdit,
          colaboradores: idColaboradorEdit,
          surtidos: idEdit,
          formaPago,
          concepto,
          bancos: selectedBanco,
          comisionPagada: "No",
          observaciones: "NA",
          codigoAgrupado,
          editado: "No",
        },
        {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          },
        }
      );

await axios.patch(
                      `${URL_SURTIDOS}/${idEdit}`,
                      {
                        saldo: 0,
                      },
                      {
                        headers: {
                          Authorization: `Bearer: ${localStorage.getItem(
                            "app_token"
                          )}`,
                        },
                      }
                    );

      await axios.post(
        URL_MOVIMIENTOS_BANCOS,
        {
          fecha,
          importe: monto,
          tipo: "Ingreso",
          bancos: selectedBanco,
          abonos: dataAbono.data._id,
          moneda,
          tipoCambio: 1,
        },
        {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          },
        }
      );

      setComments((prev) =>
        prev.map((c) =>
          c._id === idEdit
            ? {
                ...c,
                saldo: 0,
                tienePagos: "Si",
                formaPago,
                formasPago: c.formasPago
                  ? `${c.formasPago}, ${formaPago}`
                  : formaPago,
                totalPagado: (Number(c.totalPagado) || 0) + Number(monto || 0),
              }
            : c
        )
      );
      setModalPagarNota(false);
      setModalProgreso(false);
      setValidaBoton(true);
      Swal.fire("Good job!", "Creado con exito", "success");
    } catch (error) {
      console.log(error);
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: error?.response?.data?.message || "Something went wrong!",
      });
      setValidaBoton(true);
    }
  });
}

async function PDFOC(
  fecha,
  idClientes,
  clientes,
  observaciones,
  numero,
  idPDFOC,
  user,
  pedidos,
  comisionTDC,
  comisionFlete,
  instalacion,
  impuestos,
  subTotal,
  iva,
  total_general,
  calle,
  numero_ext,
  numero_int,
  pais,
  estado,
  ciudad,
  delegacion,
  colonia,
  cp,
  RFC,
  paqueteria,
  area,
  codigoClientes,
  vendedor,
  telefono,
  descuento,
  direccionEntrega
) {
  try {
    const response = await axios.get(
      `${URL_ARTICULOS_SURTIDOS}/surtido/${idPDFOC}`,
      {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      }
    );

    let allArticulosSurtido = response.data;

    let arrayTabla = allArticulosSurtido
      .map((a) => {
        return {
          id: a.inventarios?.[0]?._id,
          codigo: a.articulos?.[0]?.codigo,
          articulos: a.articulos?.[0]?.nombre,
          cantidad: a.cantidad || 0,
          cajas: a.cajas || 0,
          idArticulo: a.articulos?.[0]?._id,
          precio: a.articulosPedido?.[0]?.precio || 0,
          fotoArticulo: a.articulos?.[0]?.foto,
          foto: "",
        };
      })
      .filter((el) => el != null);

    let dataFinal = Object.values(arrayTabla);

    let agrupado = dataFinal.reduce(function (groups, item) {
      const val = item["idArticulo"];
      groups[val] = groups[val] || {
        idArticulo: item.idArticulo,
        cantidad: 0,
        cajas: 0,
      };

      groups[val].cantidad += Number(item.cantidad || 0);
      groups[val].cajas += Number(item.cajas || 0);
      groups[val].articulos = item.articulos;
      groups[val].precio = Number(item.precio || 0);
      groups[val].codigo = item.codigo;
      groups[val].foto = item.foto;
      groups[val].fotoArticulo = item.fotoArticulo;

      return groups;
    }, []);

    let agrupadoValues = Object.values(agrupado);

    let totalMts = agrupadoValues.map((c) => parseFloat(c.cantidad || 0));
    let TM = totalMts.reduce((t, total) => t + total, 0);

    let TC = agrupadoValues.map((c) => parseFloat(c.cajas || 0));
    let TTC = TC.reduce((t, total) => t + total, 0);

    let totalParcial = 0;

    const imagePromises = agrupadoValues.map(async (z) => {
      if (z.fotoArticulo === "Si") {
        try {
          const imgResponse = await axios.get(
            `${process.env.REACT_APP_URL_GETMEDIA}/${z.idArticulo}`,
            {
              headers: {
                Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
              },
            }
          );

          z.foto =
            imgResponse.data.secure_url ||
            process.env.PUBLIC_URL + "sinImagen.png";
        } catch (error) {
          console.error("Error al cargar imagen:", error);
          z.foto = process.env.PUBLIC_URL + "sinImagen.png";
        }
      } else {
        z.foto = "";
      }
    });

    await Promise.all(imagePromises);

    setTimeout(() => {
      const data = agrupadoValues.map((a) => {
        totalParcial = Number(a.cantidad || 0) * Number(a.precio || 0);

        return [
          a.foto,
          new Intl.NumberFormat("en-US").format(a.cantidad || 0),
          a.codigo || "",
          a.articulos || "",
          new Intl.NumberFormat("en-US", {
            maximumFractionDigits: 2,
          }).format(a.cantidad || 0),
          new Intl.NumberFormat("en-US", {
            style: "currency",
            currency: "USD",
            maximumFractionDigits: 2,
          }).format(a.precio || 0),
          new Intl.NumberFormat("en-US", {
            style: "currency",
            currency: "USD",
            maximumFractionDigits: 2,
          }).format(totalParcial || 0),
        ];
      });

      const dataPDF = Object.values(data);
      const dataPDFLimpia = dataPDF.filter((el) => el != null);

      const columnStyles = [
        { fontSize: 0.000001, textColor: [255, 255, 255], cellWidth: 20 },
        { fontSize: 9, textColor: ["#000000"] },
        { fontSize: 9, textColor: ["#000000"] },
        { fontSize: 9, textColor: ["#000000"] },
        { fontSize: 9, textColor: ["#000000"] },
        { fontSize: 9, textColor: ["#000000"], halign: "right" },
        { fontSize: 9, textColor: ["#000000"], halign: "right" },
      ];

      const doc = new jsPDF({ compressPdf: true });
      const img = new Image();

      const backgroundColor = ["#d1d2d4"];
      const backgroundColorBoxLightGray = ["#e6e7e9"];
      const backgroundColorBoxBlack = ["#231f20"];
      const backgroundColorBoxPurple = ["#00313c"];

      const subTotalNum = Number(subTotal || 0);
      const comisionFleteNum = Number(comisionFlete || 0);
      const comisionTDCNum = Number(comisionTDC || 0);
      const instalacionNum = Number(instalacion || 0);
      const ivaNum = Number(iva || 0);
      const descuentoNum = Number(descuento || 0);
      const descuentoTotal = (subTotalNum * descuentoNum) / 100;
      const totalFinal =
        subTotalNum +
        comisionFleteNum +
        comisionTDCNum +
        instalacionNum +
        ivaNum -
        descuentoTotal;

      img.src = process.env.PUBLIC_URL + "logoInstitucion.png";
      doc.addImage(img, "png", 5, 5, 55, 33);

      doc.setFillColor(...backgroundColor);
      doc.rect(5, 40, 200, 6, "F");
      doc.setTextColor("#000000");
      doc.setFontSize(10);
      doc.text(`Tel: 55 2522 3006`, 8, 44);

      doc.setFontSize(14);
      doc.setFillColor(...backgroundColorBoxBlack);
      doc.rect(100, 4, 105, 22, "F");
      doc.setFillColor(...backgroundColorBoxPurple);
      doc.rect(74, 4, 25, 22, "F");
      doc.setTextColor("#ffffff");
      doc.text(`NOTA DE SALIDA`, 125, 12);
      doc.setFont("helvetica", "normal");
      doc.text(`SALIDA BODEGA ${area}`, 125, 17);
      doc.text(`México, D. F. a ${fecha}`, 125, 22);

      doc.setTextColor("#000000");
      doc.setFontSize(10);
      doc.text(`Remisión: ${numero}`, 100, 44);
      doc.text(`Pedido: ${pedidos}`, 180, 44);

      let y = 52;
      const lh = 5;
      const maxW = 195;

      doc.text(
        `Cliente: ${codigoClientes} - ${clientes} Telefono: ${telefono}`,
        8,
        y
      );
      y += lh;

      const dirFiscal = `Direccion: ${calle} ${numero_ext} ${numero_int} ${estado} ${ciudad} ${cp}`;
      const dirFiscalLines = doc.splitTextToSize(dirFiscal, maxW);
      doc.text(dirFiscalLines, 8, y);
      y += dirFiscalLines.length * lh;

      const dirEntregaTxt = `Direccion Entrega: ${direccionEntrega || ""}`;
      const dirEntregaLines = doc.splitTextToSize(dirEntregaTxt, maxW);
      doc.text(dirEntregaLines, 8, y);
      y += dirEntregaLines.length * lh;

      doc.text(`Vendedor: ${vendedor}`, 8, y);
      y += lh;

      const startTableY = Math.max(70, y + 3);

      doc.autoTable({
        head: [
          [
            "",
            "CANTIDAD",
            "MODELO",
            "DESCRIPCION",
            "CANTIDAD",
            "PRECIO UNITARIO",
            "IMPORTE",
          ],
        ],
        body: dataPDFLimpia,
        bodyStyles: {
          rowHeight: 22,
          valign: "middle",
        },
        styles: {
          fontSize: 10,
        },
        headStyles: {
          fillColor: ["#00313c"],
          lineWidth: 0,
          halign: "center",
          valign: "middle",
          fontSize: 8,
        },
        footStyles: {
          fillColor: ["#00313c"],
        },
        columnStyles: columnStyles,
        theme: "grid",
        margin: { left: 5, right: 5 },
        startY: startTableY,
        showFoot: "lastPage",

        didDrawCell: function (data) {
          if (data.column.index === 0 && data.cell.section === "body") {
            const img = data.cell.raw;

            if (typeof img === "string" && img.startsWith("data:image")) {
              const { x, y } = data.cell;
              doc.addImage(img, x + 1, y + 1, 18, 18);
            }
          }
        },
      });

      doc.setFillColor(...backgroundColorBoxPurple);
      doc.rect(5, doc.autoTable.previous.finalY + 1, 36, 6, "F");
      doc.setTextColor("#ffffff");
      doc.setFontSize(8);
      doc.text(`TOTAL DE ARTICULOS`, 7, doc.autoTable.previous.finalY + 5);

      doc.setTextColor("#000000");
      doc.setFillColor(...backgroundColorBoxLightGray);
      doc.setFont("helvetica", "normal");
      doc.rect(40, doc.autoTable.previous.finalY + 1, 40, 6, "F");
      doc.text(
        new Intl.NumberFormat("en-US").format(TM) ,
        42,
        doc.autoTable.previous.finalY + 5
      );

      if (
        doc.autoTable.previous.finalY + 50 >
        doc.internal.pageSize.height - 10
      ) {
        doc.addPage();
        doc.autoTable.previous.finalY = 10;
      }

      doc.setFontSize(7.5);

      const resumenY = doc.autoTable.previous.finalY;

      // Observaciones a la izquierda, debajo de los artículos
      doc.setFont("helvetica", "bold");
      doc.setFontSize(8);
      doc.setTextColor("#000000");
      doc.text("Observaciones:", 5, resumenY + 6);
      doc.setFont("helvetica", "normal");
      const obsLinesLeft = doc.splitTextToSize(`${observaciones}`, 135);
      doc.text(obsLinesLeft, 5, resumenY + 10);

      doc.setFillColor(...backgroundColorBoxPurple);
      doc.rect(144, resumenY + 1, 37, 6, "F");
      doc.setTextColor("#ffffff");
      doc.setFont("helvetica", "bold");
      doc.setFontSize(8);
      doc.text(`SUBTOTAL $`, 153, resumenY + 5);

      doc.setFillColor(...backgroundColorBoxLightGray);
      doc.setTextColor("#000000");
      doc.setFont("helvetica", "normal");
      doc.rect(181, resumenY + 1, 24, 6, "F");
      doc.text(
        new Intl.NumberFormat("en-US", {
          style: "currency",
          currency: "USD",
          maximumFractionDigits: 2,
        }).format(subTotalNum),
        183,
        resumenY + 5
      );

      doc.setFillColor(...backgroundColorBoxPurple);
      doc.rect(144, resumenY + 8, 37, 6, "F");
      doc.setTextColor("#ffffff");
      doc.setFont("helvetica", "bold");
      doc.setFontSize(8);
      doc.text(`FLETE $`, 153, resumenY + 12);

      doc.setFillColor(...backgroundColorBoxLightGray);
      doc.setTextColor("#000000");
      doc.setFont("helvetica", "normal");
      doc.rect(181, resumenY + 8, 24, 6, "F");
      doc.text(
        new Intl.NumberFormat("en-US", {
          style: "currency",
          currency: "USD",
          maximumFractionDigits: 2,
        }).format(comisionFleteNum + comisionTDCNum),
        183,
        resumenY + 12
      );

      doc.setFillColor(...backgroundColorBoxPurple);
      doc.rect(144, resumenY + 15, 37, 6, "F");
      doc.setTextColor("#ffffff");
      doc.setFont("helvetica", "bold");
      doc.setFontSize(8);
      doc.text(`INSTALACIÓN $`, 153, resumenY + 19);

      doc.setFillColor(...backgroundColorBoxLightGray);
      doc.setTextColor("#000000");
      doc.setFont("helvetica", "normal");
      doc.rect(181, resumenY + 15, 24, 6, "F");
      doc.text(
        new Intl.NumberFormat("en-US", {
          style: "currency",
          currency: "USD",
          maximumFractionDigits: 2,
        }).format(instalacionNum),
        183,
        resumenY + 19
      );

      doc.setFillColor(...backgroundColorBoxPurple);
      doc.rect(144, resumenY + 22, 37, 6, "F");
      doc.setTextColor("#ffffff");
      doc.setFont("helvetica", "bold");
      doc.setFontSize(8);
      doc.text(`IMPUESTO $`, 153, resumenY + 26);

      doc.setFillColor(...backgroundColorBoxLightGray);
      doc.setTextColor("#000000");
      doc.setFont("helvetica", "normal");
      doc.rect(181, resumenY + 22, 24, 6, "F");
      doc.text(
        new Intl.NumberFormat("en-US", {
          style: "currency",
          currency: "USD",
          maximumFractionDigits: 2,
        }).format(ivaNum),
        183,
        resumenY + 26
      );

      doc.setFillColor(...backgroundColorBoxPurple);
      doc.rect(144, resumenY + 29, 37, 6, "F");
      doc.setTextColor("#ffffff");
      doc.setFont("helvetica", "bold");
      doc.setFontSize(8);
      doc.text(`DESCUENTO ${descuento}%`, 153, resumenY + 33);

      doc.setFillColor(...backgroundColorBoxLightGray);
      doc.setTextColor("#000000");
      doc.setFont("helvetica", "normal");
      doc.rect(181, resumenY + 29, 24, 6, "F");
      doc.text(
        new Intl.NumberFormat("en-US", {
          style: "currency",
          currency: "USD",
          maximumFractionDigits: 2,
        }).format(descuentoTotal),
        183,
        resumenY + 33
      );

      doc.setFillColor(...backgroundColorBoxPurple);
      doc.rect(144, resumenY + 36, 37, 6, "F");
      doc.setTextColor("#ffffff");
      doc.setFont("helvetica", "bold");
      doc.setFontSize(8);
      doc.text(`TOTAL $`, 153, resumenY + 40);

      doc.setFillColor(...backgroundColorBoxLightGray);
      doc.setTextColor("#000000");
      doc.setFont("helvetica", "normal");
      doc.rect(181, resumenY + 36, 24, 6, "F");
      doc.text(
        new Intl.NumberFormat("en-US", {
          style: "currency",
          currency: "USD",
          maximumFractionDigits: 2,
        }).format(totalFinal),
        183,
        resumenY + 40
      );

      // ============================================================
      // Misma hoja: FORMATO DE ENTREGA Y LIBERACIÓN DE RESPONSABILIDAD
      // ============================================================
      const libX = 5;
      const libW = 200;
      let cy = resumenY + 50;

      doc.setFont("helvetica", "bold");
      doc.setFontSize(9);
      doc.text("FORMATO DE ENTREGA Y LIBERACIÓN DE RESPONSABILIDAD", 105, cy, { align: "center" });
      cy += 12;

      doc.setFontSize(7.5);
      doc.text("DECOMAX LUXURY STYLE", libX, cy);
      cy += 3.5;

      doc.setFont("helvetica", "normal");
      doc.setFontSize(6.5);
      const introTx =
        "Por medio del presente documento, quien suscribe declara haber recibido a su entera satisfacción el material adquirido con DECOMAX LUXURY STYLE, mismo que ha sido revisado física y visualmente al momento de la entrega.";
      const introLn = doc.splitTextToSize(introTx, libW);
      doc.text(introLn, libX, cy);
      cy += introLn.length * 2.6 + 1.5;

      doc.setFont("helvetica", "bold");
      doc.text("DECLARACIÓN — El cliente manifiesta que:", libX, cy);
      cy += 3;

      doc.setFont("helvetica", "normal");
      const bl = [
        "El material ha sido recibido en perfectas condiciones, sin golpes, roturas, daños visibles, faltantes o defectos aparentes.",
        "El material fue entregado en bodega y retirado por el cliente en su vehículo particular.",
        "A partir del momento en que el material sale de la bodega, DECOMAX Luxury Style no se hace responsable por daños, golpes, roturas, faltantes, mal manejo, mala estiba, transporte inadecuado o cualquier desperfecto ocasionado durante el traslado.",
        "El cliente asume total responsabilidad del transporte, carga, sujeción y traslado del material.",
        "No se aceptarán reclamaciones posteriores relacionadas con daños ocasionados después de la salida del material de bodega.",
      ];
      bl.forEach((b) => {
        const w = doc.splitTextToSize(`• ${b}`, libW - 2);
        doc.text(w, libX + 1, cy);
        cy += w.length * 2.6 + 0.5;
      });

      cy += 1.5;
      const cierreTx =
        "El presente documento se firma como constancia de conformidad y aceptación de las condiciones antes descritas.";
      const cierreLn = doc.splitTextToSize(cierreTx, libW);
      doc.text(cierreLn, libX, cy);
      cy += cierreLn.length * 2.6 + 3;

      doc.setFont("helvetica", "bold");
      doc.setFontSize(7.5);
      doc.text("FIRMAS", libX, cy);
      cy += 4;

      doc.setFontSize(6.8);
      doc.text("Nombre y firma del cliente:", libX, cy);
      cy += 4;
      doc.setFont("helvetica", "normal");
      doc.text("Nombre completo:", libX, cy);
      doc.line(libX + 26, cy + 0.5, 105, cy + 0.5);
      doc.text("Firma:", 108, cy);
      doc.line(115, cy + 0.5, libX + libW, cy + 0.5);
      cy += 5;

      doc.setFont("helvetica", "bold");
      doc.text("Nombre y firma del personal que entrega:", libX, cy);
      cy += 4;
      doc.setFont("helvetica", "normal");
      doc.text("NOMBRE:", libX, cy);
      doc.line(libX + 15, cy + 0.5, libX + libW, cy + 0.5);
      cy += 4;

      doc.setFont("helvetica", "italic");
      doc.setFontSize(5.5);
      doc.text(
        "Este documento forma parte del proceso de entrega de material y tiene validez administrativa para ambas partes.",
        libX,
        cy
      );

      doc.save(`Nota-${numero}-${clientes}.pdf`);
    }, 1000);
  } catch (err) {
    console.error("Error al obtener datos del surtido:", err);
  }
}

async function PDFOCSinPrecios(
  fecha,
  idClientes,
  clientes,
  observaciones,
  numero,
  idPDFOC,
  user,
  pedidos,
  comisionTDC,
  comisionFlete,
  impuestos,
  subTotal,
  iva,
  total_general,
  calle,
  numero_ext,
  numero_int,
  pais,
  estado,
  ciudad,
  delegacion,
  colonia,
  cp,
  RFC,
  paqueteria,
  area,
  codigoClientes,
  vendedor,
  telefono,
  descuento,
  direccionEntrega
) {
  try {
    const response = await axios.get(
      `${URL_ARTICULOS_SURTIDOS}/surtido/${idPDFOC}`,
      {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      }
    );

    let allArticulosSurtido = response.data;

    let arrayTabla = allArticulosSurtido
      .map((a) => {
        return {
          id: a.inventarios?.[0]?._id,
          codigo: a.articulos?.[0]?.codigo,
          articulos: a.articulos?.[0]?.nombre,
          cantidad: a.cantidad || 0,
          cajas: a.cajas || 0,
          idArticulo: a.articulos?.[0]?._id,
          precio: 0,
          fotoArticulo: a.articulos?.[0]?.foto,
          foto: "",
        };
      })
      .filter((el) => el != null);

    let dataFinal = Object.values(arrayTabla);

    let agrupado = dataFinal.reduce(function (groups, item) {
      const val = item["idArticulo"];
      groups[val] = groups[val] || {
        idArticulo: item.idArticulo,
        cantidad: 0,
        cajas: 0,
      };
      groups[val].cantidad += Number(item.cantidad || 0);
      groups[val].cajas += Number(item.cajas || 0);
      groups[val].articulos = item.articulos;
      groups[val].precio = Number(item.precio || 0);
      groups[val].codigo = item.codigo;
      groups[val].foto = item.foto;
      groups[val].fotoArticulo = item.fotoArticulo;
      return groups;
    }, []);

    let agrupadoValues = Object.values(agrupado);

    let totalMts = agrupadoValues.map((c) => parseFloat(c.cantidad || 0));
    let TM = totalMts.reduce((t, total) => t + total, 0);

    let TC = agrupadoValues.map((c) => parseFloat(c.cajas || 0));
    let TTC = TC.reduce((t, total) => t + total, 0);

    let totalParcial = 0;

    // ===== CARGA IMÁGENES (igual que lo traías) =====
    const imagePromises = agrupadoValues.map(async (z) => {
      if (z.fotoArticulo === "Si") {
        try {
          const imgResponse = await axios.get(
            `${process.env.REACT_APP_URL_GETMEDIA}/${z.idArticulo}`,
            {
              headers: {
                Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
              },
            }
          );
          z.foto =
            imgResponse.data.secure_url ||
            process.env.PUBLIC_URL + "sinImagen.png";
        } catch (error) {
          console.error("Error al cargar imagen:", error);
          z.foto = process.env.PUBLIC_URL + "sinImagen.png";
        }
      } else {
        z.foto = "";
      }
    });

    await Promise.all(imagePromises);

    setTimeout(() => {
      const data = agrupadoValues.map((a) => {
        totalParcial = Number(a.cantidad || 0) * Number(a.precio || 0);
        return [
          a.foto, // (col 0)
          new Intl.NumberFormat("en-US").format(a.cantidad || 0),
          a.codigo || "",
          a.articulos || "",
          new Intl.NumberFormat("en-US", { maximumFractionDigits: 2 }).format(
            a.cantidad || 0
          ),
          new Intl.NumberFormat("en-US", {
            style: "currency",
            currency: "USD",
            maximumFractionDigits: 2,
          }).format(a.precio || 0),
          new Intl.NumberFormat("en-US", {
            style: "currency",
            currency: "USD",
            maximumFractionDigits: 2,
          }).format(totalParcial || 0),
        ];
      });

      const dataPDF = Object.values(data);
      const dataPDFLimpia = dataPDF.filter((el) => el != null);

      const columnStyles = [
        { fontSize: 0.000001, textColor: [255, 255, 255], cellWidth: 20 },
        { fontSize: 9, textColor: ["#000000"] },
        { fontSize: 9, textColor: ["#000000"] },
        { fontSize: 9, textColor: ["#000000"] },
        { fontSize: 9, textColor: ["#000000"] },
        { fontSize: 9, textColor: ["#000000"], halign: "right" },
        { fontSize: 9, textColor: ["#000000"], halign: "right" },
      ];

      const doc = new jsPDF({ compressPdf: true });
      const img = new Image();

      const backgroundColor = ["#d1d2d4"];
      const backgroundColorBoxLightGray = ["#e6e7e9"];
      const backgroundColorBoxBlack = ["#231f20"];
      const backgroundColorBoxPurple = ["#00313c"];

      img.src = process.env.PUBLIC_URL + "logoInstitucion.png";
      doc.addImage(img, "png", 5, 5, 55, 33);

      // barra gris
      doc.setFillColor(...backgroundColor);
      doc.rect(5, 40, 200, 6, "F");
      doc.setTextColor("#000000");
      doc.setFontSize(10);
      doc.text(`Tel: 55 2522 3006`, 8, 44);

      // cuadro título
      doc.setFontSize(14);
      doc.setFillColor(...backgroundColorBoxBlack);
      doc.rect(100, 4, 105, 22, "F");
      doc.setFillColor(...backgroundColorBoxPurple);
      doc.rect(74, 4, 25, 22, "F");
      doc.setTextColor("#ffffff");
      doc.text(`NOTA DE SALIDA`, 125, 12);
      doc.setFont("helvetica", "normal");
      doc.text(`SALIDA BODEGA ${area}`, 125, 17);
      doc.text(`México, D. F. a ${fecha}`, 125, 22);

      // remisión y pedido (arriba)
      doc.setTextColor("#000000");
      doc.setFontSize(10);
      doc.text(`Remisión: ${numero}`, 100, 44);
      doc.text(`Pedido: ${pedidos}`, 180, 44);

      // ====== BLOQUE DINÁMICO (AQUÍ VA EL FIX DEL ENCIMADO) ======
      let y = 52;
      const lh = 5;    // alto de línea
      const maxW = 195; // ancho aprox del texto (x=8 a x=203)

      doc.text(`Cliente: ${codigoClientes} - ${clientes} Telefono: ${telefono}`, 8, y);
      y += lh;

      const dirFiscal = `Direccion: ${calle} ${numero_ext} ${numero_int} ${estado} ${ciudad} ${cp}`;
      const dirFiscalLines = doc.splitTextToSize(dirFiscal, maxW);
      doc.text(dirFiscalLines, 8, y);
      y += dirFiscalLines.length * lh;

      const dirEntregaTxt = `Direccion Entrega: ${direccionEntrega || ""}`;
      const dirEntregaLines = doc.splitTextToSize(dirEntregaTxt, maxW);
      doc.text(dirEntregaLines, 8, y);
      y += dirEntregaLines.length * lh;

      doc.text(`Vendedor: ${vendedor}`, 8, y);
      y += lh;

      const startTableY = Math.max(70, y + 3);
      // ===========================================================

      doc.autoTable({
        head: [
          [
            "",
            "CANTIDAD",
            "MODELO",
            "DESCRIPCION",
            "CANTIDAD",
            "PRECIO UNITARIO",
            "IMPORTE",
          ],
        ],
        body: dataPDFLimpia,
        bodyStyles: {
          rowHeight: 22,
          valign: "middle",
        },
        styles: {
          fontSize: 10,
        },
        headStyles: {
          fillColor: ["#00313c"],
          lineWidth: 0,
          halign: "center",
          valign: "middle",
          fontSize: 8,
        },
        footStyles: {
          fillColor: ["#00313c"],
        },
        columnStyles: columnStyles,
        theme: "grid",
        margin: { left: 5, right: 5 },
        startY: startTableY,
        showFoot: "lastPage",

        didDrawCell: function (data) {
          if (data.column.index === 0 && data.cell.section === "body") {
            const img = data.cell.raw;

            // ✅ solo si es dataURL
            if (typeof img === "string" && img.startsWith("data:image")) {
              const { x, y } = data.cell;
              doc.addImage(img, x + 1, y + 1, 18, 18);
            }
          }
        },
      });

      // ===== Totales =====
      doc.setFillColor(...backgroundColorBoxPurple);
      doc.rect(5, doc.autoTable.previous.finalY + 1, 36, 6, "F");
      doc.setTextColor("#ffffff");
      doc.setFontSize(8);
      doc.text(`TOTAL DE ARTICULOS`, 7, doc.autoTable.previous.finalY + 5);

      doc.setTextColor("#000000");
      doc.setFillColor(...backgroundColorBoxLightGray);
      doc.setFont("helvetica", "normal");
      doc.rect(40, doc.autoTable.previous.finalY + 1, 40, 6, "F");
      doc.text(
        new Intl.NumberFormat("en-US").format(TM) ,
        42,
        doc.autoTable.previous.finalY + 5
      );

      // Si se va a salir de hoja, página nueva
      if (doc.autoTable.previous.finalY + 40 > doc.internal.pageSize.height - 10) {
        doc.addPage();
        doc.autoTable.previous.finalY = 10;
      }

      doc.setFontSize(7.5);

      // Observaciones a la izquierda, debajo de los artículos
      doc.setFont("helvetica", "bold");
      doc.setFontSize(8);
      doc.setTextColor("#000000");
      doc.text("Observaciones:", 5, doc.autoTable.previous.finalY + 6);
      doc.setFont("helvetica", "normal");
      const obsLinesLeftSP = doc.splitTextToSize(`${observaciones}`, 135);
      doc.text(obsLinesLeftSP, 5, doc.autoTable.previous.finalY + 10);

      // ===== Resumen derecha =====
      doc.setFillColor(...backgroundColorBoxPurple);
      doc.rect(144, doc.autoTable.previous.finalY + 1, 37, 6, "F");
      doc.setTextColor("#ffffff");
      doc.setFont("helvetica", "bold");
      doc.setFontSize(8);
      doc.text(`SUBTOTAL $`, 153, doc.autoTable.previous.finalY + 5);

      doc.setFillColor(...backgroundColorBoxLightGray);
      doc.setTextColor("#000000");
      doc.setFont("helvetica", "normal");
      doc.rect(181, doc.autoTable.previous.finalY + 1, 24, 6, "F");
      doc.text(
        new Intl.NumberFormat("en-US", {
          style: "currency",
          currency: "USD",
          maximumFractionDigits: 2,
        }).format(Number(0)),
        183,
        doc.autoTable.previous.finalY + 5
      );

      doc.setFillColor(...backgroundColorBoxPurple);
      doc.rect(144, doc.autoTable.previous.finalY + 8, 37, 6, "F");
      doc.setTextColor("#ffffff");
      doc.setFont("helvetica", "bold");
      doc.setFontSize(8);
      doc.text(`FLETE $`, 153, doc.autoTable.previous.finalY + 12);

      doc.setFillColor(...backgroundColorBoxLightGray);
      doc.setTextColor("#000000");
      doc.setFont("helvetica", "normal");
      doc.rect(181, doc.autoTable.previous.finalY + 8, 24, 6, "F");
      doc.text(
        new Intl.NumberFormat("en-US", {
          style: "currency",
          currency: "USD",
        }).format(Number(0) + Number(0)),
        183,
        doc.autoTable.previous.finalY + 12
      );

      doc.setFillColor(...backgroundColorBoxPurple);
      doc.rect(144, doc.autoTable.previous.finalY + 15, 37, 6, "F");
      doc.setTextColor("#ffffff");
      doc.setFont("helvetica", "bold");
      doc.setFontSize(8);
      doc.text(`IMPUESTO $`, 153, doc.autoTable.previous.finalY + 19);

      doc.setFillColor(...backgroundColorBoxLightGray);
      doc.setTextColor("#000000");
      doc.setFont("helvetica", "normal");
      doc.rect(181, doc.autoTable.previous.finalY + 15, 24, 6, "F");
      doc.text(
        new Intl.NumberFormat("en-US", {
          style: "currency",
          currency: "USD",
        }).format(Number(0)),
        183,
        doc.autoTable.previous.finalY + 19
      );

      doc.setFillColor(...backgroundColorBoxPurple);
      doc.rect(144, doc.autoTable.previous.finalY + 22, 37, 6, "F");
      doc.setTextColor("#ffffff");
      doc.setFont("helvetica", "bold");
      doc.setFontSize(8);
      doc.text(`DESCUENTO ${0}%`, 153, doc.autoTable.previous.finalY + 26);

      doc.setFillColor(...backgroundColorBoxLightGray);
      doc.setTextColor("#000000");
      doc.setFont("helvetica", "normal");
      doc.rect(181, doc.autoTable.previous.finalY + 22, 24, 6, "F");
      doc.text(
        new Intl.NumberFormat("en-US", { maximumFractionDigits: 2 }).format(
          ((Number(0) * Number(0)) / 100).toFixed(2)
        ),
        183,
        doc.autoTable.previous.finalY + 26
      );

      doc.setFillColor(...backgroundColorBoxPurple);
      doc.rect(144, doc.autoTable.previous.finalY + 29, 37, 6, "F");
      doc.setTextColor("#ffffff");
      doc.setFont("helvetica", "bold");
      doc.setFontSize(8);
      doc.text(`TOTAL $`, 153, doc.autoTable.previous.finalY + 34);

      doc.setFillColor(...backgroundColorBoxLightGray);
      doc.setTextColor("#000000");
      doc.setFont("helvetica", "normal");
      doc.rect(181, doc.autoTable.previous.finalY + 29, 24, 6, "F");
      doc.text(
        new Intl.NumberFormat("en-US", {
          style: "currency",
          currency: "USD",
          maximumFractionDigits: 2,
        }).format(Number(0)),
        183,
        doc.autoTable.previous.finalY + 34
      );

      // ============================================================
      // Misma hoja: FORMATO DE ENTREGA Y LIBERACIÓN DE RESPONSABILIDAD
      // ============================================================
      const libX = 5;
      const libW = 200;
      let cy = doc.autoTable.previous.finalY + 42;

      doc.setFont("helvetica", "bold");
      doc.setFontSize(11);
      doc.text("FORMATO DE ENTREGA Y LIBERACIÓN DE RESPONSABILIDAD", 105, cy, { align: "center" });
      cy += 6;

      doc.setFontSize(9);
      doc.text("DECOMAX LUXURY STYLE", libX, cy);
      cy += 4.5;

      doc.setFont("helvetica", "normal");
      doc.setFontSize(8);
      const introTx =
        "Por medio del presente documento, quien suscribe declara haber recibido a su entera satisfacción el material adquirido con DECOMAX LUXURY STYLE, mismo que ha sido revisado física y visualmente al momento de la entrega.";
      const introLn = doc.splitTextToSize(introTx, libW);
      doc.text(introLn, libX, cy);
      cy += introLn.length * 3.4 + 2;

      doc.setFont("helvetica", "bold");
      doc.text("DECLARACIÓN — El cliente manifiesta que:", libX, cy);
      cy += 4;

      doc.setFont("helvetica", "normal");
      const bl = [
        "El material ha sido recibido en perfectas condiciones, sin golpes, roturas, daños visibles, faltantes o defectos aparentes.",
        "El material fue entregado en bodega y retirado por el cliente en su vehículo particular.",
        "A partir del momento en que el material sale de la bodega, DECOMAX Luxury Style no se hace responsable por daños, golpes, roturas, faltantes, mal manejo, mala estiba, transporte inadecuado o cualquier desperfecto ocasionado durante el traslado.",
        "El cliente asume total responsabilidad del transporte, carga, sujeción y traslado del material.",
        "No se aceptarán reclamaciones posteriores relacionadas con daños ocasionados después de la salida del material de bodega.",
      ];
      bl.forEach((b) => {
        const w = doc.splitTextToSize(`• ${b}`, libW - 2);
        doc.text(w, libX + 1, cy);
        cy += w.length * 3.4 + 0.8;
      });

      cy += 2;
      const cierreTx =
        "El presente documento se firma como constancia de conformidad y aceptación de las condiciones antes descritas.";
      const cierreLn = doc.splitTextToSize(cierreTx, libW);
      doc.text(cierreLn, libX, cy);
      cy += cierreLn.length * 3.4 + 4;

      doc.setFont("helvetica", "bold");
      doc.setFontSize(9);
      doc.text("FIRMAS", libX, cy);
      cy += 5;

      doc.setFontSize(8.5);
      doc.text("Nombre y firma del cliente:", libX, cy);
      cy += 5;
      doc.setFont("helvetica", "normal");
      doc.text("Nombre completo:", libX, cy);
      doc.line(libX + 30, cy + 0.5, 105, cy + 0.5);
      doc.text("Firma:", 108, cy);
      doc.line(120, cy + 0.5, libX + libW, cy + 0.5);
      cy += 6;

      doc.setFont("helvetica", "bold");
      doc.text("Nombre y firma del personal que entrega:", libX, cy);
      cy += 5;
      doc.setFont("helvetica", "normal");
      doc.text("NOMBRE:", libX, cy);
      doc.line(libX + 18, cy + 0.5, libX + libW, cy + 0.5);
      cy += 5;

      doc.setFont("helvetica", "italic");
      doc.setFontSize(7);
      doc.text(
        "Este documento forma parte del proceso de entrega de material y tiene validez administrativa para ambas partes.",
        libX,
        cy
      );

      doc.save(`Nota-${numero}-${clientes}.pdf`);
    }, 1000);
  } catch (err) {
    console.error("Error al obtener datos del surtido:", err);
  }
}

   async function excelOC(id, numero) {
    await axios
    .get(`${URL_ARTICULOS_SURTIDOS}/surtido/${id}`, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allArticulosPedido = response.data;
        let arrayTabla = allArticulosPedido
          .map((a) => {
            return {
               id: a.inventarios[0]._id,
              codigo: a.articulos[0].codigo,
              articulo: a.articulos[0].nombre,
              cantidad: a.cantidad,
              idArticulo: a.articulos[0]._id,
              precio: a.articulosPedido[0].precio,
              cajas: a.cantidad / a.articulos[0].piezasPorCaja,
            };
          })
          .filter(function (el) {
            return el != null;
          });

        const dataExportExcel = Object.values(arrayTabla);
        const dataExcelLimpia = dataExportExcel.filter(function (el) {
          return el != null;
        });

        var option = {};

        option.fileName = `Venta ${numero}`;

        option.datas = [
          {
            sheetData: dataExcelLimpia,
            sheetFilter: [
              "codigo",
              "articulo",
              "cantidad",
              "precio",
            ],
            sheetHeader: [
               "codigo",
              "articulo",
              "cantidad",
              "precio",
            ],
          },
        ];

        var toExcel = new ExportJsonExcel(option);
        toExcel.saveExcel();
      })
      .catch((err) => {
        console.log(err);
      });
  }

  const headers = [
    { name: "☐", field: "check", sortable: false },
    { name: "Numero", field: "numero", sortable: true },
    { name: "Fecha", field: "fecha", sortable: true },
    { name: "Empresa", field: "empresas", sortable: true },
    { name: "Cliente", field: "clientes", sortable: true },
    { name: "Almacen", field: "area", sortable: true },
    { name: "Vendedor", field: "vendedor", sortable: true },
    { name: "Departamento", field: "departamentoName", sortable: true },
    { name: "Metodo Entrega", field: "metodoEntrega", sortable: true },
    { name: "Fecha Entrega", field: "fechaEntrega", sortable: true },
    { name: "SubTotal", field: "subTotal", sortable: true },
    { name: "Total", field: "total_general", sortable: true },
    { name: "Saldo", field: "saldo", sortable: true },
    { name: "Impuestos", field: "impuestosLetra", sortable: true },
    { name: "Piezas", field: "total_cantidad", sortable: true },
    { name: "Factura", field: "factura", sortable: true },
    { name: "Sol. Factura", field: "solicitarFactura", sortable: true },
    { name: "Factura Hecha", field: "facturaHecha", sortable: true },
    { name: "Forma de Pago", field: "formaPago", sortable: true },
    { name: "Banco", field: "banco", sortable: true },
    { name: "Detalles", field: "acciones", sortable: false },
  ];

  const commentsData = useMemo(() => {
    let computedComments = comments;
    if (search) {
      computedComments = computedComments.filter(
        (comment) =>
          comment.clientes.toLowerCase().includes(search.toLowerCase()) ||
        comment.empresas.toLowerCase().includes(search.toLowerCase()) ||
          comment.area.toLowerCase().includes(search.toLowerCase()) ||
          comment.vendedor.toLowerCase().includes(search.toLowerCase()) ||
          comment.departamentoName.toLowerCase().includes(search.toLowerCase()) ||
          comment.metodoEntrega.toLowerCase().includes(search.toLowerCase()) ||
          comment.factura.toLowerCase().includes(search.toLowerCase()) ||
          comment.impuestosLetra.toLowerCase().includes(search.toLowerCase()) ||
          comment.formaPago.toLowerCase().includes(search.toLowerCase()) ||
          comment.pedidos.toString().includes(search) ||
          comment.numero.toString().includes(search) ||
          comment.subTotal.toString().includes(search) ||
          comment.total_general.toString().includes(search) ||
          comment.saldo.toString().includes(search)
      );
    }
    if (selectedCliente) {
      computedComments = computedComments.filter((e) =>
        e.idClientes.includes(selectedCliente)
      );
    }
    if (selectedEmpresa) {
      computedComments = computedComments.filter((e) =>
        e.idEmpresa.includes(selectedEmpresa)
      );
    }
        if (selectedMetodo) {
      computedComments = computedComments.filter((e) =>
        e.metodoEntrega.includes(selectedMetodo)
      );
    }
    if (selectedColaborador) {
      computedComments = computedComments.filter((e) =>
        e.idVendedor.includes(selectedColaborador)
      );
    }
    if (selectedUser) {
      computedComments = computedComments.filter((e) =>
        e.idUser.includes(selectedUser)
      );
    }
    if (selectedActivo) {
      computedComments = computedComments.filter((e) =>
        e.is_active.includes(selectedActivo)
      );
    }
    if (selectedEntregado) {
      computedComments = computedComments.filter((e) =>
        e.entregada.includes(selectedEntregado)
      );
    }

    if (selectedFechaInicio) {
      computedComments = computedComments.filter(
        (e) => e.fecha >= selectedFechaInicio
      );
    }

    if (selectedFechaFin) {
      computedComments = computedComments.filter(
        (e) => e.fecha <= selectedFechaFin
      );
    }
    if (selectedDepartamento) {
      computedComments = computedComments.filter((e) =>
        e.idDepartamento.includes(selectedDepartamento)
      );
    }

    if (selectedSaldo == "Si") {
      computedComments = computedComments.filter(
        (e) => e.saldo > 0
      );
    }

    if (selectedSaldo == "No") {
      computedComments = computedComments.filter(
        (e) => e.saldo == 0
      );
    }

    if (selectedSolicitarFactura) {
      computedComments = computedComments.filter(
        (e) => e.solicitarFactura == selectedSolicitarFactura
      );
    }

    if (selectedFacturaHecha) {
      computedComments = computedComments.filter(
        (e) => e.facturaHecha == selectedFacturaHecha
      );
    }

    let activos = computedComments.filter((e) => e.is_active == "Si");

    let cant = activos.map((c) => parseFloat(c.total_cantidad));
    let TC = cant.reduce((t, total, index) => t + total, 0);
    setTotalPiezasTabla(TC);

    let sub = activos.map((c) => parseFloat(c.subTotal));
    let TS = sub.reduce((t, total, index) => t + total, 0);
    setSubTotalImporteTabla(TS);

    let to = activos.map((c) => parseFloat(c.total_general));
    let TT = to.reduce((t, total, index) => t + total, 0);
    setTotalImporteTabla(TT);

    setTotalItems(computedComments.length);

    //Sorting comments
    if (
      sorting.field &&
      sorting.field != "pedidos" &&
      sorting.field != "numero" &&
      sorting.field != "total_cantidad" &&
      sorting.field != "subTotal" &&
      sorting.field != "total_general" &&
      sorting.field != "saldo"
    ) {
      const reversed = sorting.order === "asc" ? 1 : -1;
      computedComments = computedComments.sort(
        (a, b) => reversed * a[sorting.field].localeCompare(b[sorting.field])
      );
    }

    if (
      sorting.field &&
      sorting.order === "asc" &&
      (sorting.field == "pedidos" ||
        sorting.field == "numero" ||
        sorting.field == "total_cantidad" ||
        sorting.field == "subTotal" ||
        sorting.field == "total_general" ||
        sorting.field == "saldo")
    ) {
      computedComments = computedComments.sort((a, b) =>
        parseFloat(a[sorting.field]) > parseFloat(b[sorting.field]) ? 1 : -1
      );
    }

    if (
      sorting.field &&
      sorting.order === "desc" &&
      (sorting.field == "pedidos" ||
        sorting.field == "numero" ||
        sorting.field == "total_cantidad" ||
        sorting.field == "subTotal" ||
        sorting.field == "total_general" ||
        sorting.field == "saldo")
    ) {
      computedComments = computedComments.sort((a, b) =>
        parseFloat(a[sorting.field]) < parseFloat(b[sorting.field]) ? 1 : -1
      );
    }

    //Current Page slice
    return computedComments.slice(
      (currentPage - 1) * ITEMS_PER_PAGE,
      (currentPage - 1) * ITEMS_PER_PAGE + ITEMS_PER_PAGE
    );
  }, [
    comments,
    currentPage,
    search,
    sorting,
    selectedCliente,
    selectedEmpresa,
    selectedMetodo,
    selectedColaborador,
    selectedUser,
    selectedFechaInicio,
    selectedFechaFin,
    selectedDepartamento,
    selectedActivo,
    selectedEntregado,
    selectedSaldo,
    selectedSolicitarFactura,
    selectedFacturaHecha
  ]);

  function saveFotoEvidencia() {
    Swal.fire({
      title: `Por favor espere...`,
      html: "data uploading",
      allowOutsideClick: false,
      onBeforeOpen: () => {
        Swal.showLoading();
      },
    });

    // Si hay impuestos sube la evidencia 2
    if (impuestosMail == 16) {
      const formData2 = new FormData();
      formData2.append("file", fileFotoEvidencia2);
      formData2.append("nombre", `${idEvidencia}`);

      axios
        .post(URL_UPMEDIA, formData2, {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          },
        })
        .then(() => {
          setFotoEvidencia2("Si");
          axios
            .patch(
              `${URL_SURTIDOS}/${idEvidencia}`,
              {
                fotoEvidencia: "Si",
                mail: "Si",
                noFactura,
                noGuia
              },
              {
                headers: {
                  Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
                },
              }
            )
            .then(() => {
              setComments((prev) =>
                prev.map((c) =>
                  c._id === idEvidencia
                    ? { ...c, fotoEvidencia: "Si", mail: "Si", noFactura, noGuia }
                    : c
                )
              );
              Swal.fire({
                position: "center",
                icon: "success",
                title: "Enviado con exito!",
                showConfirmButton: false,
                timer: 1500,
              });
            })
            .catch((error) => {
              Swal.fire({
                icon: "error",
                title: "Oops...",
                text: "Something went wrong!",
                footer: `${error.response.data}`,
              });
              console.log(error);
            });
        })
        .catch((error) => {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: "Something went wrong!",
            footer: `${error.response.data}`,
          });
          console.log(error);
        });
    }

    const formData = new FormData();
    formData.append("file", fileFotoEvidencia);
    formData.append("nombre", `${idEvidencia}`);

    axios
      .post(URL_UPMEDIA, formData, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then(() => {
        setFotoEvidencia("Si");
        axios
          .patch(
            `${URL_SURTIDOS}/${idEvidencia}`,
            {
              fotoEvidencia: "Si",
              mail: "Si",
              noGuia,
            },
            {
              headers: {
                Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
              },
            }
          )
          .then(() => {
            setComments((prev) =>
              prev.map((c) =>
                c._id === idEvidencia
                  ? { ...c, fotoEvidencia: "Si", mail: "Si", noGuia }
                  : c
              )
            );
            Swal.fire({
              position: "center",
              icon: "success",
              title: `Se guardaron los datos`,
              showConfirmButton: false,
              timer: 1000,
            });
          })
          .catch((error) => {
            Swal.fire({
              icon: "error",
              title: "Oops...",
              text: "Something went wrong!",
              footer: `${error.response.data}`,
            });
            console.log(error);
          });
      })
      .catch((error) => {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong!",
          footer: `${error.response.data}`,
        });
        console.log(error);
      });

    // if (enviarMail == "No") {
    axios
      .get(`${URL_ARTICULOS_SURTIDOS}/surtido/${idPDFOCMail}`, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allArticulosSurtido = response.data;
        let arrayTabla = [];

        if (allArticulosSurtido.length > 10) {
          arrayTabla = allArticulosSurtido.map((a) => {
            return {
              id: a.inventarios[0]._id,
              codigo: a.articulos[0].codigo,
              articulos: a.articulos[0].nombre + " " + a.articulos[0].lineas[0].name + " " + a.articulos[0].familias[0].name,
              cantidad: a.cantidad,
              idArticulo: a.articulos[0]._id,
              precio: a.articulosPedido[0].precio,
              cajas: a.cantidad / a.articulos[0].piezasPorCaja,
              fotoArticulo: a.articulos[0].foto,
              foto: process.env.PUBLIC_URL + "sinImagen.png",
            };
          }).filter(function (el) {
            return el != null;
          });
        } else {
          arrayTabla = allArticulosSurtido.map((a) => {
            let foto = a.articulos[0].foto === "No"
              ? process.env.PUBLIC_URL + "sinImagen.png"
              : a.articulos[0].urlFoto;
        
            return {
              id: a.inventarios[0]._id,
              codigo: a.articulos[0].codigo,
              articulos: a.articulos[0].nombre + " " + a.articulos[0].lineas[0].name + " " + a.articulos[0].familias[0].name,
              cantidad: a.cantidad,
              idArticulo: a.articulos[0]._id,
              precio: a.articulosPedido[0].precio,
              cajas: a.cantidad / a.articulos[0].piezasPorCaja,
              fotoArticulo: a.articulos[0].foto,
              foto: foto,
            };
          }).filter(function (el) {
            return el != null;
          });
        }

        let dataFinal = Object.values(arrayTabla);

        let agrupado = dataFinal.reduce(function (groups, item) {
          const val = item["idArticulo"];
          groups[val] = groups[val] || {
            idArticulo: item.idArticulo,
            cantidad: 0,
            cajas: 0,
          };
          groups[val].cantidad += item.cantidad;
          groups[val].cajas += item.cajas;
          groups[val].articulos = item.articulos;
          groups[val].precio = item.precio;
          groups[val].codigo = item.codigo;
          groups[val].foto = item.foto;
          groups[val].fotoArticulo = item.fotoArticulo;
          return groups;
        }, []);

        let agrupadoValues = Object.values(agrupado);
        let totalMts = agrupadoValues.map((c) => parseFloat(c.cantidad));
        let TM = totalMts.reduce((t, total, index) => t + total, 0);

        let TC = agrupadoValues.map((c) => parseFloat(c.cajas));
        let TTC = TC.reduce((t, total, index) => t + total, 0);

        let totalParcial = 0;

        const data = agrupadoValues.map((a) => {
          totalParcial = a.cantidad * a.precio;
          return [
            a.foto,
            new Intl.NumberFormat("en-US").format(a.cantidad),
            a.codigo,
            a.articulos,
            new Intl.NumberFormat("en-US", {
              maximumFractionDigits: 2,
            }).format(a.cajas),
            new Intl.NumberFormat("en-US", {
              style: "currency",
              currency: "USD",
              maximumFractionDigits: 2,
            }).format(a.precio),
            new Intl.NumberFormat("en-US", {
              style: "currency",
              currency: "USD",
              maximumFractionDigits: 2,
            }).format(totalParcial),
          ];
        });

        const dataPDF = Object.values(data);
        const dataPDFLimpia = dataPDF.filter(function (el) {
          return el != null;
        });

        const columnStyles = [
          { fontSize: .000001, textColor: [255, 255, 255], cellWidth: 20, },
          { fontSize: 9, textColor: ["#000000"] },
          { fontSize: 9, textColor: ["#000000"] },
          { fontSize: 9, textColor: ["#000000"] },
          { fontSize: 9, textColor: ["#000000"] },
          { fontSize: 9, textColor: ["#000000"] },
          { fontSize: 9, textColor: ["#000000"], halign: "right" },
          { fontSize: 9, textColor: ["#000000"], halign: "right" },
        ];

        const doc = new jsPDF({ compressPdf: true });
        var img = new Image();
        var img2 = new Image();
        const backgroundColor = ["#d1d2d4"];
        const backgroundColorBoxLightGray = ["#e6e7e9"];
        const backgroundColorBoxBlack = ["#231f20"];
        const backgroundColorBoxPurple = ["#00313c"];
        const margins = { left: 5, right: 5 };

        img.src = process.env.PUBLIC_URL + "logoInstitucion.png";
        doc.addImage(img, "png", 5, 5, 55, 33);

        // img.src = process.env.PUBLIC_URL + "marcas.png";
        // doc.addImage(img, "png", 9, 28, 192, 10);
        // doc.setFontSize(10);

        doc.setFillColor(...backgroundColor);
        doc.rect(5, 40, 200, 6, "F");
        doc.setTextColor("#000000");
        doc.text(`Tel: 55 2522 3006`, 8, 44);

        doc.setTextColor("#000000");
        doc.text(`Cliente: ${codigoClientesMail} - ${clientesMail}`, 8, 52);
        doc.text(`Remisión: ${numeroMail}`, 80, 52);
        doc.text(`Pedido: ${pedidosMail}`, 160, 52);

        doc.setTextColor("#00313c");
        doc.setFontSize(12);
        doc.setFont("helvetica", "bold");
        doc.text(`decomax.mx`, 175, 44);
        doc.setTextColor("#000000");

        doc.setFontSize(14);
        doc.setFillColor(...backgroundColorBoxBlack);
        doc.rect(100, 4, 105, 22, "F");
        doc.setFillColor(...backgroundColorBoxPurple);
        doc.rect(74, 4, 25, 22, "F");
        doc.setTextColor("#ffffff");
        doc.text(`NOTA DE SALIDA`, 125, 12);
        doc.setFont("helvetica", "normal");
        doc.text(`SALIDA BODEGA`, 125, 17);
        doc.text(`México, D. F. a ${fechaMail}`, 125, 22);

        doc.autoTable({
          head: [
            [
              "",
              "CANTIDAD",
              "MODELO",
              "DESCRIPCION",
              "BULTO#",
              "PRECIO UNITARIO",
              "IMPORTE",
            ],
          ],
          body: dataPDFLimpia,
          bodyStyles:{
            rowHeight : 22,
            valign: "middle"
          },
          styles: {
            fontSize: 10,
            overflow: "linebreak",
            columnWidth: "wrap",
            // font: 'arial',
            overflowColumns: "linebreak",
          },
          headStyles: {
            fillColor: ["#00313c"],
            lineWidth: 0,
            halign: "center",
            valign: "middle",
            fontSize: 8,
          },
          footStyles: {
            fillColor: ["#00313c"],
          },
          columnStyles: columnStyles,
          theme: "grid",
          margin: { left: 5, right: 5 },
          startY: 55,
          showFoot: "lastPage",


        didDrawCell: function(data) {
          if (data.column.index === 0 && data.cell.section === 'body') {
             var td = data.cell.raw;
             var img = td
            //  var dim = data.cell.height - data.cell.padding('vertical');
             var textPos = data.cell;
             doc.addImage(img, textPos.x,  textPos.y, 20, 20);
          }
        },

        });


        doc.setFillColor(...backgroundColorBoxPurple);
        doc.rect(5, doc.autoTable.previous.finalY + 1, 36, 6, "F");
        doc.setTextColor("#ffffff");
        doc.setFontSize(8);
        doc.text(`TOTAL DE ARTICULOS`, 7, doc.autoTable.previous.finalY + 5);
        doc.setTextColor("#000000");
        doc.text(
          `________________________________________________________________________________________________________________________________`,
          5,
          doc.autoTable.previous.finalY + 22
        );

        doc.setFillColor(...backgroundColorBoxLightGray);
        doc.setFont("helvetica", "normal");
        doc.rect(40, doc.autoTable.previous.finalY + 1, 40, 6, "F");
        doc.text(
          new Intl.NumberFormat("en-US").format(TM) ,
          42,
          doc.autoTable.previous.finalY + 5
        );

        doc.setFontSize(7.5);
        doc.text(
          `1. Esta es una venta en firme y no se acepta ningún tipo de descuento o devolución sin consentimiento previo.`,
          5,
          doc.autoTable.previous.finalY + 11
        );
doc.text(
        `2. La mercancía viaja por flete pagado por el cliente. DECOMAX Luxury Style no se hace responsable por material`,
        5,
        doc.autoTable.previous.finalY + 14
      );
      doc.text(
        `faltante una vez firmado de conformidad el documento de entrega. Cualquier aclaración posterior a la recepción`,
        5,
        doc.autoTable.previous.finalY + 17
      );
      doc.text(
        `y firma del material quedará fuera de nuestra responsabilidad.`,
        5,
        doc.autoTable.previous.finalY + 20
      );
      doc.text(
        `3. El pago de la mercancía debe realizarse en tiempo y forma pactados a la cuenta proporcionada por nosotros.`,
        5,
        doc.autoTable.previous.finalY + 23
      );

        var observaciones = `Observaciones: ${observacionesMail}`;
        var lines = doc.splitTextToSize(observaciones, 129);
        doc.text(5, doc.autoTable.previous.finalY + 29, lines);

        doc.setFillColor(...backgroundColorBoxPurple);
        doc.rect(144, doc.autoTable.previous.finalY + 1, 37, 6, "F");
        doc.setTextColor("#ffffff");
        doc.setFont("helvetica", "bold");
        doc.setFontSize(8);
        doc.text(`SUBTOTAL $`, 153, doc.autoTable.previous.finalY + 5);

        doc.setFillColor(...backgroundColorBoxLightGray);
        doc.setTextColor("#000000");
        doc.setFont("helvetica", "normal");
        doc.rect(181, doc.autoTable.previous.finalY + 1, 24, 6, "F");
        doc.text(
          new Intl.NumberFormat("en-US", {
            style: "currency",
            currency: "USD",
            maximumFractionDigits: 2,
          }).format(subTotalMail.toFixed(2)),
          183,
          doc.autoTable.previous.finalY + 5
        );

        doc.setFillColor(...backgroundColorBoxPurple);
        doc.rect(144, doc.autoTable.previous.finalY + 8, 37, 6, "F");
        doc.setTextColor("#ffffff");
        doc.setFont("helvetica", "bold");
        doc.setFontSize(8);
        doc.text(`IMPUESTO $`, 154, doc.autoTable.previous.finalY + 12);

        doc.setFillColor(...backgroundColorBoxLightGray);
        doc.setTextColor("#000000");
        doc.setFont("helvetica", "normal");
        doc.rect(181, doc.autoTable.previous.finalY + 8, 24, 6, "F");
        doc.text(
          new Intl.NumberFormat("en-US").format(ivaMail),
          183,
          doc.autoTable.previous.finalY + 12
        );

        doc.setFillColor(...backgroundColorBoxPurple);
        doc.rect(144, doc.autoTable.previous.finalY + 15, 37, 6, "F");
        doc.setTextColor("#ffffff");
        doc.setFont("helvetica", "bold");
        doc.setFontSize(8);
        doc.text(`TOTAL $`, 159, doc.autoTable.previous.finalY + 19);

        doc.setFillColor(...backgroundColorBoxLightGray);
        doc.setTextColor("#000000");
        doc.setFont("helvetica", "normal");
        doc.rect(181, doc.autoTable.previous.finalY + 15, 24, 6, "F");
        doc.text(
          new Intl.NumberFormat("en-US", {
            style: "currency",
            currency: "USD",
            maximumFractionDigits: 2,
          }).format(total_generalMail.toFixed(2)),
          183,
          doc.autoTable.previous.finalY + 19
        );

        var lines = doc.splitTextToSize(`Observaciones: ${observaciones}`, 40);
        doc.text(145, doc.autoTable.previous.finalY + 26, lines);

        doc.setFont("helvetica", "bold");
        doc.text(
          `Nombre Completo:__________________________________________________________________________  Firma:______________________________`,
          5,
          doc.autoTable.previous.finalY + 50
        );

        doc.setFont("helvetica", "normal");
        doc.setFontSize(6);
        doc.text(
          `ESTE DOCUMENTO NO REPRESENTA UN COMPROBANTE FISCAL`,
          67,
          doc.autoTable.previous.finalY + 60
        );

        // Agrega Evidencia 1
        doc.addPage();
        var img2 = new Image();
        img2.src = URL.createObjectURL(fileFotoEvidencia);

        doc.addImage(img2, "png", 10, 10, 190, 270);

        // Agrega Evidencia 2
        if (impuestosMail == 16) {
          doc.addPage();
          var img3 = new Image();
          img3.src = URL.createObjectURL(fileFotoEvidencia2);

          doc.addImage(img3, "png", 10, 10, 190, 270);
        }

        var att = doc.output("arraybuffer");
        var base64File = encode(att);

        // Envia el Mail
        axios.post(
          URL_SEND_MAIL_ATT,
          {
            subject: `Nota-${numeroMail}.pdf`,
            email: process.env.REACT_APP_MAIL_ADMIN,
            fileName: `Nota-${numeroMail}.pdf`,
            att: base64File,
            text: `<table border="0" cellpadding="0" cellspacing="0" width="100%">
                         <th><img width="${
                           process.env.REACT_APP_TAMANO_LOGO_MAIL
                         }" align="center" src="${
              process.env.REACT_APP_LINK_SISTEMA
            }logoInstitucion.png" /></th>
                         <tr align="center" style="font-size:30px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px;font-weight:bold"><br>${
                           process.env.REACT_APP_NOMBRE_INSTITUCION
                         }</tr>
                         <tbody>
                         <tr style="font-size:14px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px;font-weight:bold"><br>Ciudad de México a ${fechaMail}</tr>
                         <tr style="font-size:14px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px;font-weight:bold"><br>Estimado Cliente: ${clientesMail}</tr>
                         <tr style="font-size:14px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px;font-weight:bold"><br>Muy buen día, por medio del presente le doy conocimiento que el día ${fechaMail}, hemos embarcado a ustedes mercancía. Le pido tome nota de la siguiente información:</tr>
                         <tr style="font-size:14px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px;><br>Empresa de Transporte: ${paqueteriaMail}.</tr>
                         <tr style="font-size:14px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px;><br>Numero de guía: ${paqueteriaMail}.</tr>
                         <tr style="font-size:14px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px;><br>Numero de bultos: ${TTC.toFixed(
                           2
                         )}</tr>
                         <tr style="font-size:14px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px;><br>Nota / Factura: ${numeroMail}</tr>
                         <tr style="font-size:14px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px;><br>Valor de la Venta: $${new Intl.NumberFormat(
                           "en-US",
                           {
                             style: "currency",
                             currency: "USD",
                             maximumFractionDigits: 2,
                           }
                         ).format(total_generalMail)}</tr>
                         <tr style="font-size:14px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px;><br>Plazo convenido: ${plazoMail}</tr>
                         <br>
                         <tr style="font-size:14px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px;><br>Adjunto Documento de Venta.</tr>
                         <tr style="font-size:14px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px;><br>Quedamos a sus órdenes para cualquier duda o aclaración.</tr>
                         <br>
                         <tr style="font-size:14px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px;"><br>Atentamente ,</tr>
                         <tr style="font-size:14px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px;"><br>${process.env.REACT_APP_NOMBRE_INSTITUCION}</tr>
                         </tbody>
                         <tr style="font-size:16px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px"><br>Favor de no responder este correo, para cualquier duda favor de comunicarse al ${
                           process.env.REACT_APP_TELEFONO_INSTITUCION
                         }</tr>
                         
                         </table>`,
          },
          {
            headers: {
              Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
            },
          }
        );
        // .then(() => {

        // let params = new URLSearchParams({
        //   number: telefonoMail,
        //   message:`Hola ${clientesMail}, Aqui te enviamos la nueva nota de venta`,
        //   fileName:`Nota-${numeroMail}.pdf`,
        //   mimetype: "application/pdf",
        // })
        // axios
        // .post(
        //   `${URL_WHATSAPP}SendPDFFront?${params.toString()}`,
        //   att,
        //   {
        //     headers: {
        //       Authorization: `Bearer: ${localStorage.getItem(
        //         "app_token"
        //       )}`,
        //       "Content-Type": "application/octet-stream",
        //     },
        //   }
        // )
        //   .then(() => {
        //     Swal.fire("Good job!", "Enviado con exito", "success");
        //     setTimeout(() => {
        //       window.location.reload();
        //     }, 1000);
        //   })
        //   .catch((error) => {
        //     Swal.fire({
        //       icon: "error",
        //       title: "Oops...",
        //       text: "Something went wrong!",
        //       footer: `${error.response.data}`,
        //     });
        //   });

      })

      // .catch((error) => {
      //   Swal.fire({
      //     icon: "error",
      //     title: "Oops...",
      //     text: "Something went wrong!",
      //     footer: `${error.response.data}`,
      //   });
      //   console.log(error);
      // });

      // })
      .catch((err) => {
        console.log(err);
      });
    // }
  }

  function jalaFotoEvidencia(id) {
    setPhotoEvidencia("")
    const URL_GET_MEDIA = `${process.env.REACT_APP_URL_FINDMEDIABYTAG}/${id}`;
    axios
      .get(URL_GET_MEDIA, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((data) => {
        setPhotoEvidencia(data.data.resources);
      })
      .catch((err) => console.log(err));
    toggleVerFotoEvidencia();
  }

  async function enviarWhatsapp(
    fecha,
    idClientes,
    clientes,
    observaciones,
    numero,
    idPDFOC,
    user,
    pedidos,
    comisionTDC,
    comisionFlete,
    impuestos,
    subTotal,
    iva,
    total_general,
    calle,
    numero_ext,
    numero_int,
    pais,
    estado,
    ciudad,
    delegacion,
    colonia,
    cp,
    RFC,
    paqueteria,
    area,
    codigoClientes,
    vendedor,
    telefono
  ) {
    Swal.fire({
      title: "Estas seguro?",
      text: `Se enviara la Nota al telefono ${telefono}`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Si, Enviar!",
    }).then(async (result) => {
      if (result.isConfirmed) {
        await axios
          .get(`${URL_ARTICULOS_SURTIDOS}/surtido/${idPDFOC}`, {
            headers: {
              Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
            },
          })
          .then((response) => {
            let allArticulosSurtido = response.data;
            let arrayTabla = allArticulosSurtido
              .map((a) => {
                return {
                  id: a.inventarios[0]._id,
                  articulos:
                    a.articulos[0].nombre +
                    " " +
                    a.articulos[0].lineas[0].name +
                    " " +
                    a.articulos[0].familias[0].name,
                  cantidad: a.cantidad,
                  idArticulo: a.articulos[0]._id,
                  precio: a.articulosPedido[0].precio,
                  cajas: a.cantidad / a.articulos[0].piezasPorCaja,
                };
              })
              .filter(function (el) {
                return el != null;
              });

            let dataFinal = Object.values(arrayTabla);

            let agrupado = dataFinal.reduce(function (groups, item) {
              const val = item["idArticulo"];
              groups[val] = groups[val] || {
                idArticulo: item.idArticulo,
                cantidad: 0,
                cajas: 0,
              };
              groups[val].cantidad += item.cantidad;
              groups[val].cajas += item.cajas;
              groups[val].articulos = item.articulos;
              groups[val].precio = item.precio;
              return groups;
            }, []);

            let agrupadoValues = Object.values(agrupado);

            let totalMts = agrupadoValues.map((c) => parseFloat(c.cantidad));
            let TM = totalMts.reduce((t, total, index) => t + total, 0);

            let TC = agrupadoValues.map((c) => parseFloat(c.cajas));
            let TTC = TC.reduce((t, total, index) => t + total, 0);

            let totalParcial = 0;

            const data = agrupadoValues.map((a) => {
              totalParcial = a.cantidad * a.precio;
              return [
                a.articulos,
                new Intl.NumberFormat("en-US", {
                  maximumFractionDigits: 2,
                }).format(a.cajas),
                new Intl.NumberFormat("en-US").format(a.cantidad),
                new Intl.NumberFormat("en-US", {
                  style: "currency",
                  currency: "USD",
                  maximumFractionDigits: 2,
                }).format(a.precio),
                new Intl.NumberFormat("en-US", {
                  style: "currency",
                  currency: "USD",
                  maximumFractionDigits: 2,
                }).format(totalParcial),
              ];
            });

            const dataPDF = Object.values(data);
            const dataPDFLimpia = dataPDF.filter(function (el) {
              return el != null;
            });
            const doc = new jsPDF({ compressPdf: true });
            var img = new Image();
            var img2 = new Image();
            img2.src = process.env.PUBLIC_URL + "logoInstitucion.png";
            doc.addImage(img2, "png", 10, 21, 30, 25);

            let alto = 5;

            doc.setFontSize(14);
            doc.text(`DECOMAX S.A. DE C.V.`, 50, alto + 15);
            doc.setFontSize(10);
            doc.text(
              `Callejon Mixcalco 9`,
              50,
              alto + 20
            );
            doc.text(`Lomas de Chapultepec II Seccion, CDMX, 11000`, 50, alto + 25);
            doc.text(
              `Miguel Hidalgo CDMX, Mexico `,
              50,
              alto + 30
            );

            doc.setFontSize(10);
            doc.text(`Fecha:`, 150, alto + 15);
            doc.text(`${fecha}`, 160, alto + 15);
            doc.text(`Nota:`, 150, alto + 20);
            doc.text(`${numero}`, 160, alto + 20);

            doc.setFontSize(10);
            doc.text(`Cliente: ${codigoClientes} - ${clientes}`, 10, alto + 55);
            doc.text(`RFC: ${RFC}`, 150, alto + 55);
            doc.text(
              `Direccion de Envio: ${calle} #${numero_ext} Int. ${numero_int} Telefono: ${telefono}`,
              10,
              alto + 65
            );
            doc.text(
              `Edo: ${estado}, Ciudad: ${ciudad}, Del: ${delegacion}, Col: ${colonia}, CP: ${cp} Paqueteria: ${paqueteria}`,
              10,
              alto + 70
            );

            doc.autoTable({
              head: [["Articulo", "Cajas", "Cantidad", "Precio", "Total"]],
              body: dataPDFLimpia,
              headStyles: {
                fillColor: ["#00313c"],
                lineWidth: 0,
              },
              footStyles: {
                fillColor: ["#00313c"],
              },
              theme: "grid",
              styles: {
                fontSize: 10,
                overflow: "linebreak",
                columnWidth: "wrap",
                // font: 'arial',
                overflowColumns: "linebreak",
              },
              headStyles: {
                fillColor: ["#00313c"],
                lineWidth: 0,
              },
              footStyles: {
                fillColor: ["#00313c"],
              },
              theme: "grid",
              margin: { left: 5, right: 5 },
              startY: 80,
              foot: [
                [
                  "",
                  new Intl.NumberFormat("en-US").format(TTC.toFixed(2)) +
                    " Cajas",
                  new Intl.NumberFormat("en-US").format(TM) ,
                  "Sub Total",
                  new Intl.NumberFormat("en-US", {
                    style: "currency",
                    currency: "USD",
                    maximumFractionDigits: 2,
                  }).format(subTotal.toFixed(2)),
                ],
                [
                  "",
                  "",
                  "",
                  `Comision`,
                  new Intl.NumberFormat("en-US", {
                    style: "currency",
                    currency: "USD",
                    maximumFractionDigits: 2,
                  }).format(iva.toFixed(2)),
                ],
                [
                  "",
                  "",
                  "",
                  "Comision TDC",
                  new Intl.NumberFormat("en-US", {
                    style: "currency",
                    currency: "USD",
                    maximumFractionDigits: 2,
                  }).format(comisionTDC.toFixed(2)),
                ],
                [
                  "",
                  "",
                  "",
                  "Comision Flete",
                  new Intl.NumberFormat("en-US", {
                    style: "currency",
                    currency: "USD",
                    maximumFractionDigits: 2,
                  }).format((comisionFlete + comisionTDC).toFixed(2)),
                ],
                [
                  "",
                  "",
                  "",
                  "Total",
                  new Intl.NumberFormat("en-US", {
                    style: "currency",
                    currency: "USD",
                    maximumFractionDigits: 2,
                  }).format(total_general.toFixed(2)),
                ],
              ],
              showFoot: "lastPage",
            });

            var attW = doc.output("arraybuffer");

          let params = new URLSearchParams({
            number: telefono,
            message:`Hola ${clientes}, Aquí te enviamos la nota de venta #${numero}`,
            fileName:`Nota-${numero}.pdf`,
            mimetype: "application/pdf",
          })
          axios
          .post(
            `${URL_WHATSAPP}SendPDFFront?${params.toString()}`,
            attW,
            {
              headers: {
                Authorization: `Bearer: ${localStorage.getItem(
                  "app_token"
                )}`,
                "Content-Type": "application/octet-stream",
              },
            }
          )
        })
          .catch((err) => {
            console.log(err);
          });
      }
    });
  }

    function EditNota(id, clientes, numero, factura) {

    setIdEdit(id);
    setClienteEdit(clientes);
    setNumeroEdit(numero);
    setFacturaEdit(factura);

    toggleEditNota();
  }

    function saveEditarNota(){
    axios.patch(
      `${URL_SURTIDOS}/${idEdit}`,
      {
        noFactura: facturaEdit,
      },
      {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem(
            "app_token"
          )}`,
        },
      }
    )
    .then(() => {
      axios.post(
        URL_LOGS,
        {
          tipo: "Editar Nota",
          detalle: `${numeroEdit} ${clienteEdit}`,
          user: user.id,
        },
        {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          },
        }
      );
      // axios.patch(
      //   URL_SIGNUP_DON,
      //   {
      //     nombre: nombre,
      //     apellido: apellido,
      //     email: email,
      //   },
      //   {
      //     headers: {
      //       Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
      //     },
      //   }
      // );
      toggleEditNota();
      Swal.fire("Good job!", "Actualizado con exito", "success");
      // setTimeout(() => {
      //   window.location.reload();
      // }, 1000);
    })


    .catch((error) => {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Something went wrong!",
      });
      console.log(error);
    });



  }

  function toggleFacturaHecha(id, valorActual) {
    const nuevo = valorActual === "Si" ? "No" : "Si";
    Swal.fire({
      title: `¿Marcar Factura Hecha como "${nuevo}"?`,
      icon: "question",
      showCancelButton: true,
      confirmButtonText: "Sí, cambiar",
      cancelButtonText: "Cancelar",
    }).then((result) => {
      if (!result.isConfirmed) return;
      axios
        .patch(
          `${URL_SURTIDOS}/${id}`,
          { facturaHecha: nuevo },
          {
            headers: {
              Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
            },
          }
        )
        .then(() => {
          setComments((prev) =>
            prev.map((c) => (c._id === id ? { ...c, facturaHecha: nuevo } : c))
          );
        })
        .catch((err) => {
          console.log(err);
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: "No se pudo actualizar Factura Hecha",
          });
        });
    });
  }

  function toggleSolicitarFactura(id, valorActual) {
    const nuevo = valorActual === "Si" ? "No" : "Si";
    Swal.fire({
      title: `¿Marcar Solicitar Factura como "${nuevo}"?`,
      icon: "question",
      showCancelButton: true,
      confirmButtonText: "Sí, cambiar",
      cancelButtonText: "Cancelar",
    }).then((result) => {
      if (!result.isConfirmed) return;
      axios
        .patch(
          `${URL_SURTIDOS}/${id}`,
          { solicitarFactura: nuevo },
          {
            headers: {
              Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
            },
          }
        )
        .then(() => {
          setComments((prev) =>
            prev.map((c) =>
              c._id === id ? { ...c, solicitarFactura: nuevo } : c
            )
          );
        })
        .catch((err) => {
          console.log(err);
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: "No se pudo actualizar Solicitar Factura",
          });
        });
    });
  }

  async function previewFacturar(a) {
    try {
      const headers = { Authorization: `Bearer: ${localStorage.getItem("app_token")}` };
      const [resArts, resCli, resEmp, resSeries] = await Promise.all([
        axios.get(`${URL_ARTICULOS_SURTIDOS}/surtido/${a._id}`, { headers }),
        axios.get(`${URL_CLIENTES}/${a.idClientes}`, { headers }),
        axios.get(`${URL_EMPRESAS}/${a.idEmpresa}`, { headers }),
        axios.get(`${URL_SERIES}Timbres`, { headers }),
      ]);
      setFacturarArticulos(resArts.data || []);
      setFacturarCliente(resCli.data || null);
      setFacturarEmpresa(resEmp.data || null);
      setFacturarSeries(Array.isArray(resSeries.data) ? resSeries.data : []);
      setFacturarTimbres(
        Array.isArray(resSeries.data) && resSeries.data[0]
          ? resSeries.data[0].folio
          : 0
      );
      setFacturarSerie(
        Array.isArray(resSeries.data) && resSeries.data[0]
          ? resSeries.data[0].serie || ""
          : ""
      );
      setFacturarSurtido(a);
      toggleFacturarPreview();
    } catch (err) {
      console.log(err);
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "No se pudo cargar la vista previa de la factura",
      });
    }
  }

  async function confirmarFacturar() {
    if (!facturarSurtido) return;
    if (facturarTimbres <= 0) {
      Swal.fire({ icon: "error", title: "Sin timbres", text: "No hay timbres disponibles" });
      return;
    }
    if (!facturarSerie) {
      Swal.fire({ icon: "error", title: "Serie", text: "Selecciona una serie" });
      return;
    }
    const confirm = await Swal.fire({
      title: "¿Confirmas facturar esta nota?",
      text: `Nota ${facturarSurtido.numero} — Cliente ${facturarSurtido.clientes}`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Sí, timbrar",
    });
    if (!confirm.isConfirmed) return;

    try {
      setFacturando(true);
      const headers = { Authorization: `Bearer: ${localStorage.getItem("app_token")}` };
      const surtido = facturarSurtido;
      const cliente = facturarCliente || {};
      const empresa = facturarEmpresa || {};

      // Validación previa: campos fiscales mínimos requeridos por Facturama
      if (!cliente.razon_social || !cliente.RFC || !cliente.usoCFDI) {
        setFacturando(false);
        Swal.fire({
          icon: "error",
          title: "Datos fiscales incompletos",
          text: "El cliente no tiene Razón Social, RFC o Uso CFDI capturado",
        });
        return;
      }
      if (!empresa.razonSocial || !empresa.rfc || empresa.razonSocial === "NA" || empresa.rfc === "NA") {
        setFacturando(false);
        Swal.fire({
          icon: "error",
          title: "Empresa no configurada",
          text: "La empresa emisora no tiene Razón Social o RFC capturados",
        });
        return;
      }

      // Regla SAT CFDI 4.0: si MetodoPago = PPD, FormaPago debe ser "99"
      let formaPagoFinal = cliente.formaPagoSAT;
      if (cliente.metodoPagoSAT === "PPD") {
        formaPagoFinal = "99";
      }

      // Convertir descuento (porcentaje) a monto
      const descuentoPct = Number(surtido.descuento || 0);
      const descuentoMonto = (Number(surtido.subTotal || 0) * descuentoPct) / 100;

      const facturaResp = await axios.post(
        URL_FACTURAS,
        {
          fecha: surtido.fecha,
          observaciones: "NA",
          totalCantidad: surtido.total_cantidad,
          subTotal: parseFloat(surtido.subTotal).toFixed(2),
          iva: parseFloat(surtido.iva).toFixed(2),
          total: parseFloat(surtido.total_general).toFixed(2),
          abonos: 0,
          saldo: parseFloat(surtido.total_general).toFixed(2),
          pagado: "No",
          descuentoPorcentaje1: descuentoPct.toFixed(2),
          descuentoNumero1: descuentoMonto.toFixed(2),
          descuentoConcepto1: "NA",
          descuentoPorcentaje2: 0,
          descuentoNumero2: 0,
          descuentoConcepto2: "NA",
          empresas: surtido.idEmpresa,
          clientes: surtido.idClientes,
          colaboradores: surtido.idVendedor,
          timbre: "No",
          currency: "MXN",
          cfdiType: "I",
          serie: facturarSerie,
          expeditionPlace: empresa.cp,
          rfcEmpresa: empresa.rfc,
          nombreEmpresa: empresa.razonSocial,
          regFiscalEmpresa: empresa.regimenFiscal,
          condicionesPagoSATCliente: cliente.condicionesPagoSAT,
          formaPagoSATCliente: formaPagoFinal,
          metodoPagoSATCliente: cliente.metodoPagoSAT,
          rfcCliente: cliente.RFC,
          nombreCliente: cliente.razon_social,
          usoCFDICliente: cliente.usoCFDI,
          regFiscalCliente: Number(cliente.regFiscal || 0),
          cpCliente: cliente.cp,
          numeroPagos: 0,
        },
        { headers }
      );

      const facturaId = facturaResp.data._id;

      await axios.patch(
        `${URL_SURTIDOS}Factura/${surtido._id}`,
        { facturas: facturaId, facturado: "Si" },
        { headers }
      );

      await axios.post(
        `${URL_TIMBRAR}Factura`,
        { facturas: facturaId },
        { headers }
      );

      await axios.post(
        URL_LOGS,
        {
          tipo: "Crear Factura",
          detalle: `Factura desde Nota ${surtido.numero}`,
          user: user.id,
        },
        { headers }
      );

      // Actualizar la fila localmente sin recargar la página
      setComments((prev) =>
        prev.map((c) =>
          c._id === surtido._id
            ? {
                ...c,
                facturado: "Si",
                factura: `${facturarSerie || ""}${(facturarSeries.find((s) => s.serie === facturarSerie)?.folio || 0) + 1}`,
              }
            : c
        )
      );
      setFacturando(false);
      setModalFacturarPreview(false);
      Swal.fire("Good job!", "Factura timbrada", "success");
    } catch (error) {
      console.log(error);
      setFacturando(false);
      const data = error?.response?.data;

      // Errores del backend (Decomax) — vienen con .message + arrays de detalle
      if (data?.articulosSinSAT) {
        const lista = data.articulosSinSAT.map((a) => `• ${a.codigo} — ${a.descripcion}`).join("\n");
        Swal.fire({ icon: "error", title: "Artículos sin Clave SAT", text: data.message, footer: `<pre style="text-align:left">${lista}</pre>` });
        return;
      }
      if (data?.articulosClaveSATInvalida) {
        const lista = data.articulosClaveSATInvalida
          .map((a) => `• ${a.codigo} — ${a.descripcion} (Clave SAT actual: "${a.codigoSATActual}")`)
          .join("\n");
        Swal.fire({ icon: "error", title: "Clave SAT inválida", text: data.message, footer: `<pre style="text-align:left">${lista}</pre>` });
        return;
      }
      if (data?.camposFaltantes) {
        Swal.fire({
          icon: "error",
          title: "Datos fiscales faltantes",
          text: data.message,
          footer: `<pre style="text-align:left">${data.camposFaltantes.join("\n")}</pre>`,
        });
        return;
      }
      if (data?.articulos) {
        const lista = data.articulos
          .map((a) => `• ${a.codigo} — cantidad: ${a.cantidad}, precio: ${a.precio}`)
          .join("\n");
        Swal.fire({ icon: "error", title: "Cantidades/Precios inválidos", text: data.message, footer: `<pre style="text-align:left">${lista}</pre>` });
        return;
      }

      // Errores que vienen directo de Facturama (con Message y ModelState)
      if (data?.Message) {
        let detalle = "";
        if (data.ModelState) {
          detalle = Object.entries(data.ModelState)
            .map(([campo, msgs]) => `${campo}: ${(Array.isArray(msgs) ? msgs : [msgs]).join(", ")}`)
            .join("\n");
        }
        let mensajeTitulo = "Facturama rechazó el CFDI";
        let mensajeTexto = data.Message;
        // Heurística: error de catálogo SAT (FormatException en GetDataCatalog)
        if (
          data.ExceptionType?.includes("FormatException") ||
          (data.StackTrace || "").includes("GetDataCatalog")
        ) {
          mensajeTitulo = "Clave SAT inválida en el catálogo de Facturama";
          mensajeTexto =
            "Alguno de los artículos tiene una Clave SAT (codigoSAT) o Clave de Unidad que Facturama no reconoce. Revisa el catálogo de Artículos y captura una clave válida (ej. 53102501 para ropa).";
        }
        Swal.fire({
          icon: "error",
          title: mensajeTitulo,
          text: mensajeTexto,
          footer: detalle ? `<pre style="text-align:left;max-height:200px;overflow:auto">${detalle}</pre>` : "",
        });
        return;
      }

      // Fallback
      Swal.fire({
        icon: "error",
        title: "Error al facturar",
        text: data?.message || error?.message || "Error desconocido",
      });
    }
  }



  return (
    <>
      <Header />
      <br />
      <br />
      {user.menu_ventas ? (
        <div className="card col-12">
          <Row>
            <Col md={8}>
              {/* <Button
                size="sm"
                href="/MenuAdmin"
                className="btn btn-danger"
                id="botonListado"
              >
                Regresar
              </Button> */}
            </Col>
            <Col sm={4}>
              <ButtonGroup id="logoutBoton">
                <Button
                  size="sm"
                  className="btn"
                  color="danger"
                  onClick={PDFTabla}
                >
                  PDF <i class="far fa-file-pdf"></i>
                </Button>
                <Button
                  size="sm"
                  className="btn"
                  onClick={toggleMail}
                  color="info"
                >
                  eMail <i class="fas fa-at"></i>
                </Button>
                <Button
                  size="sm"
                  className="btn"
                  color="primary"
                  onClick={excel}
                >
                  Excel <i class="far fa-file-excel"></i>
                </Button>
              </ButtonGroup>
            </Col>
          </Row>
          <Modal size="sm" isOpen={modalMail} toggle={toggleMail}>
            <ModalHeader toggle={toggleMail}>
              <h4>Enviar Listado de Notas</h4>
            </ModalHeader>
            <ModalBody>
              <Label className="mr-sm-2">Email</Label>
              <Input
                className="col-sm-12"
                type="text"
                value={mailTo}
                required
                onChange={(e) => {
                  setMailTo(e.target.value);
                }}
              />
            </ModalBody>
            <ModalFooter>
              <Button size="sm" color="success" onClick={enviaMail}>
                Enviar
              </Button>
            </ModalFooter>
          </Modal>
          <h3 align="center">Ventas</h3>
          <div className="row">
            <div className="col-md-8">
              <Pagination
                total={totalItems}
                itemsPerPage={ITEMS_PER_PAGE}
                currentPage={currentPage}
                onPageChange={(page) => setCurrentPage(page)}
              />
            </div>
            <div className="col-md-4 d-flex flex-row-reverse">
              <Search
                onSearch={(value) => {
                  setSearch(value);
                  setCurrentPage(1);
                }}
              />
            </div>
          </div>
          <Row>
            <Col md={2}>
              <Label className="mr-sm-2">Fecha Inicio</Label>
              <Input
                bsSize="sm"
                type="date"
                value={selectedFechaInicio}
                required
                onChange={(e) => {
                  setSelectedFechaInicio(e.target.value);
                }}
              />
            </Col>
            <Col md={2}>
              <Label className="mr-sm-2">Fecha Fin</Label>
              <Input
                bsSize="sm"
                type="date"
                value={selectedFechaFin}
                required
                onChange={(e) => {
                  setSelectedFechaFin(e.target.value);
                }}
              />
            </Col>

            <Col md={2}>
              <Label>Activa</Label>
              <Input
                bsSize="sm"
                type="select"
                value={selectedActivo}
                onChange={(e) => {
                  setSelectedActivo(e.target.value);
                  setCurrentPage(1);
                }}
              >
                <option value="">Selecciona</option>
                <option value="Si">Si</option>
                <option value="No">No</option>
              </Input>
            </Col>
            <Col md={2}>
              <Label>Entregada</Label>
              <Input
                bsSize="sm"
                type="select"
                value={selectedEntregado}
                onChange={(e) => {
                  setSelectedEntregado(e.target.value);
                  setCurrentPage(1);
                }}
              >
                <option value="">Selecciona</option>
                <option value="Si">Si</option>
                <option value="No">No</option>
              </Input>
            </Col>
            <Col md={2}>
              <Label className="mr-sm-2">Saldo</Label>
            <Input
                bsSize="sm"
                type="select"
                value={selectedSaldo}
                onChange={(e) => {
                  setSelectedSaldo(e.target.value);
                  setCurrentPage(1);
                }}
              >
                <option value="">Selecciona</option>
                <option value="Si">Pendientes</option>
                <option value="No">Liquidadas</option>
              </Input>
            </Col>
            <Col md={2}>
              <Label className="mr-sm-2">Solicitar Factura</Label>
              <Input
                bsSize="sm"
                type="select"
                value={selectedSolicitarFactura}
                onChange={(e) => {
                  setSelectedSolicitarFactura(e.target.value);
                  setCurrentPage(1);
                }}
              >
                <option value="">Todos</option>
                <option value="Si">Si</option>
                <option value="No">No</option>
              </Input>
            </Col>
            <Col md={2}>
              <Label className="mr-sm-2">Factura Hecha</Label>
              <Input
                bsSize="sm"
                type="select"
                value={selectedFacturaHecha}
                onChange={(e) => {
                  setSelectedFacturaHecha(e.target.value);
                  setCurrentPage(1);
                }}
              >
                <option value="">Todos</option>
                <option value="Si">Si</option>
                <option value="No">No</option>
              </Input>
            </Col>
          </Row>
          <br />
          <Row className="mb-2">
            <Col>
              {(() => {
                const visiblesNoEntregadas = commentsData.filter(
                  (c) => c.is_active === "Si" && c.entregada === "No"
                );
                const idsVisibles = visiblesNoEntregadas.map((c) => c._id);
                const todasSel =
                  idsVisibles.length > 0 &&
                  idsVisibles.every((id) => selectedNotasEntrega.includes(id));
                return (
                  <>
                    <Button
                      size="sm"
                      color={todasSel ? "warning" : "info"}
                      onClick={() => {
                        if (todasSel) {
                          // deseleccionar solo las visibles
                          setSelectedNotasEntrega((prev) =>
                            prev.filter((id) => !idsVisibles.includes(id))
                          );
                        } else {
                          // agregar todas las visibles no entregadas
                          setSelectedNotasEntrega((prev) =>
                            Array.from(new Set([...prev, ...idsVisibles]))
                          );
                        }
                      }}
                      disabled={idsVisibles.length === 0}
                    >
                      {todasSel
                        ? "Deseleccionar visibles"
                        : `Seleccionar todas visibles (${idsVisibles.length})`}
                    </Button>{" "}
                    <Button
                      size="sm"
                      color="success"
                      onClick={entregarNotasSeleccionadas}
                      disabled={selectedNotasEntrega.length === 0}
                    >
                      <i className="fas fa-check"></i> Entregar seleccionadas
                      {selectedNotasEntrega.length > 0
                        ? ` (${selectedNotasEntrega.length})`
                        : ""}
                    </Button>
                  </>
                );
              })()}
            </Col>
          </Row>
          <Table size="sm" striped borderless className="table-responsive-xl">
            <TableHeader
              headers={headers}
              onSorting={(field, order) => setSorting({ field, order })}
            />
            <tr>
              <td></td>
              <td></td>
              <td></td>
              <td style={{ paddingTop: "0px" }}>
                <Input
                  bsSize="sm"
                  type="select"
                  value={selectedEmpresa}
                  onChange={(e) => {
                    setSelectedEmpresa(e.target.value);
                    setCurrentPage(1);
                  }}
                >
                  <option value="0">Selecciona</option>
                  {empresas
                    .sort((a, b) => (a.name > b.name ? 1 : -1))
                    .map((a) => {
                      return <option value={a._id}>{a.name}</option>;
                    })}
                </Input>
              </td>
              <td style={{ paddingTop: "0px" }}>
                <Input
                  bsSize="sm"
                  type="select"
                  value={selectedCliente}
                  onChange={(e) => {
                    setSelectedCliente(e.target.value);
                    setCurrentPage(1);
                  }}
                >
                  <option value="0">Selecciona</option>
                  {clientes
                    .sort((a, b) =>
                      a.nombre_comercial > b.nombre_comercial ? 1 : -1,
                    )
                    .map((a) => {
                      return (
                        <option value={a._id}>{a.nombre_comercial}</option>
                      );
                    })}
                </Input>
              </td>
              <td></td>
              <td style={{ paddingTop: "0px" }}>
                <Input
                  bsSize="sm"
                  type="select"
                  value={selectedColaborador}
                  onChange={(e) => {
                    setSelectedColaborador(e.target.value);
                    setCurrentPage(1);
                  }}
                >
                  <option value="0">Selecciona</option>
                  {colaboradores
                    .sort((a, b) => (a.nombre > b.nombre ? 1 : -1))
                    .map((a) => {
                      return (
                        <option value={a._id}>
                          {a.nombre} {a.apellido}
                        </option>
                      );
                    })}
                </Input>
              </td>
              <td></td>

              <td style={{ paddingTop: "0px" }}>
                <Input
                  bsSize="sm"
                  type="select"
                  value={selectedMetodo}
                  onChange={(e) => {
                    setSelectedMetodo(e.target.value);
                    setCurrentPage(1);
                  }}
                >
                  <option value="">Selecciona</option>
                  <option value="Flete Roberto">Flete Roberto</option>
          <option value="Flete Omar">Flete Omar</option>
          <option value="Flete Edward">Flete Edward</option>
          <option value="Flete Lalamove">Flete Lalamove</option>
          <option value="Flete Otro">Flete Otro</option>
          <option value="Paqueteria Paquetexpress">Paqueteria Paquetexpress</option>
          <option value="Paqueteria Almex">Paqueteria Almex</option>
          <option value="Paqueteria Tresguerras">Paqueteria Tresguerras</option>
          <option value="Paqueteria FedEx">Paqueteria FedEx</option>
          <option value="Paqueteria DHL">Paqueteria DHL</option>
          <option value="Paqueteria Castores">Paqueteria Castores</option>
          <option value="Cliente Recoge">Cliente Recoge</option>
                </Input>
              </td>
            </tr>
            <tbody>
              {commentsData.map((a) => {
                // ============================
                // COLORES DE FILA (PRIORIDAD)
                // ============================
                let rowStyle = null;

                // ❌ CANCELADA (rojo claro)
                if (a.is_active === "No") {
                  rowStyle = { backgroundColor: "#ed8c8c" };
                }
                // 🟠 ACTIVA CON SALDO
                else if (a.is_active === "Si" && Number(a.saldo) > 0) {
                  rowStyle = { backgroundColor: "#a88fd6ff" }; // naranja
                }
                // 🟡 SIN EVIDENCIA Y VENCIDA
                else if (a.fotoEvidencia === "No" && evidencia5 > a.fecha) {
                  rowStyle = { backgroundColor: "#fff2b2" };
                }

                if (a.is_active === "No") {
                  return (
                    <tr>
                      {/*<tr style={rowStyle}>*/}
                      <td></td>
                      <td>{a.numero}</td>
                      <td>{a.fecha}</td>
                      <td>{a.empresas}</td>
                      <td>{a.clientes}</td>
                      <td>{a.area}</td>
                      <td>{a.vendedor}</td>
                      <td>{a.departamentoName}</td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td>CANCELADA</td>
                    </tr>
                  );
                }

                return (
                  <tr>
                    {/*<tr style={rowStyle}>*/}
                    <td>
                      {a.entregada === "No" ? (
                        <Input
                          type="checkbox"
                          style={{ position: "relative", margin: 0 }}
                          checked={selectedNotasEntrega.includes(a._id)}
                          onChange={() => toggleSelectNota(a._id)}
                          title="Seleccionar para entregar en lote"
                        />
                      ) : (
                        <i className="fas fa-check text-success" title="Ya entregada"></i>
                      )}
                    </td>
                    <td>{a.numero}</td>
                    <td>{a.fecha}</td>
                    <td>{a.empresas}</td>
                    <td>{a.clientes}</td>
                    <td>{a.area}</td>
                    <td>{a.vendedor}</td>
                    <td>{a.departamentoName}</td>
                    <td>{a.metodoEntrega}</td>
                    <td>{a.fechaEntrega}</td>

                    <td>
                      {new Intl.NumberFormat("en-US", {
                        style: "currency",
                        currency: "USD",
                        maximumFractionDigits: 2,
                      }).format(a.subTotal)}
                    </td>

                    <td>
                      {new Intl.NumberFormat("en-US", {
                        style: "currency",
                        currency: "USD",
                        maximumFractionDigits: 2,
                      }).format(a.total_general)}
                    </td>
                     <td>
                      {new Intl.NumberFormat("en-US", {
                        style: "currency",
                        currency: "USD",
                        maximumFractionDigits: 2,
                      }).format(a.saldo)}
                    </td>

                    <td>{a.impuestosLetra}</td>
                    <td>
                      {new Intl.NumberFormat("en-US").format(a.total_cantidad)}
                    </td>

                    <td>{a.factura}</td>
                    <td>
                      <Button
                        size="sm"
                        color={a.solicitarFactura === "Si" ? "success" : "secondary"}
                        onClick={() =>
                          user.vendedor === "Si"
                            ? null
                            : toggleSolicitarFactura(a._id, a.solicitarFactura)
                        }
                        disabled={user.vendedor === "Si"}
                        title={
                          user.vendedor === "Si"
                            ? "Solo Administradores pueden cambiar este valor"
                            : "Click para alternar Si/No"
                        }
                      >
                        {a.solicitarFactura}
                      </Button>
                    </td>
                    <td>
                      <Button
                        size="sm"
                        color={a.facturaHecha === "Si" ? "success" : "secondary"}
                        onClick={() =>
                          user.vendedor === "Si"
                            ? null
                            : toggleFacturaHecha(a._id, a.facturaHecha)
                        }
                        disabled={user.vendedor === "Si"}
                        title={
                          user.vendedor === "Si"
                            ? "Solo Administradores pueden cambiar este valor"
                            : "Click para alternar Si/No"
                        }
                      >
                        {a.facturaHecha}
                      </Button>
                    </td>
                    <td>{a.formaPago}</td>
                    <td>{a.banco}</td>

                    <td>
                      <>
                        <Button
                          size="sm"
                          className="btn"
                          color="danger"
                          onClick={() =>
                            PDFOC(
                              a.fecha,
                              a.idClientes,
                              a.clientes,
                              a.observaciones,
                              a.numero,
                              a._id,
                              a.user,
                              a.pedidos,
                              a.comisionTDC,
                              a.comisionFlete,
                              a.comisionInstalacion,
                              a.impuestos,
                              a.subTotal,
                              a.iva,
                              a.total_general,
                              a.calle,
                              a.numero_ext,
                              a.numero_int,
                              a.pais,
                              a.estado,
                              a.ciudad,
                              a.delegacion,
                              a.colonia,
                              a.cp,
                              a.RFC,
                              a.paqueteria,
                              a.area,
                              a.codigoClientes,
                              a.vendedor,
                              a.telefono,
                              a.descuento,
                              a.direccionEntrega,
                            )
                          }
                        >
                          <i className="far fa-file-pdf"></i>
                        </Button>
                        <Button
                          size="sm"
                          className="btn"
                          color="Info"
                          onClick={() =>
                            PDFOCSinPrecios(
                              a.fecha,
                              a.idClientes,
                              a.clientes,
                              a.observaciones,
                              a.numero,
                              a._id,
                              a.user,
                              a.pedidos,
                              a.comisionTDC,
                              a.comisionFlete,
                              a.impuestos,
                              a.subTotal,
                              a.iva,
                              a.total_general,
                              a.calle,
                              a.numero_ext,
                              a.numero_int,
                              a.pais,
                              a.estado,
                              a.ciudad,
                              a.delegacion,
                              a.colonia,
                              a.cp,
                              a.RFC,
                              a.paqueteria,
                              a.area,
                              a.codigoClientes,
                              a.vendedor,
                              a.telefono,
                              a.descuento,
                              a.direccionEntrega,
                            )
                          }
                        >
                          <i className="far fa-file-pdf"></i>
                        </Button>

                        {user.altaEvidencia ? (
                          <Button
                            size="sm"
                            color="gris"
                            onClick={() => {
                              setidEvidencia(a._id);
                              setFotoEvidencia(a.fotoEvidencia);
                              setEnviarMail(a.mail);
                              setFechaMail(a.fecha);
                              setIdClientesMail(a.idClientes);
                              setClientesMail(a.clientes);
                              setObservacionesMail(a.observaciones);
                              setNumeroMail(a.numero);
                              setIdPDFOCMail(a._id);
                              setUserMail(a.user);
                              setPedidosMail(a.pedidos);
                              setComisionTDCMail(a.comisionTDC);
                              setComisionFleteMail(a.comisionFlete);
                              setImpuestosMail(a.impuestos);
                              setSubTotalMail(a.subTotal);
                              setIvaMail(a.iva);
                              setTotal_generalMail(a.total_general);
                              setCalleMail(a.calle);
                              setNumero_extMail(a.numero_ext);
                              setNumero_intMail(a.numero_int);
                              setPaisMail(a.pais);
                              setEstadoMail(a.estado);
                              setCiudadMail(a.ciudad);
                              setDelegacionMail(a.delegacion);
                              setColoniaMail(a.colonia);
                              setCpMail(a.cp);
                              setRFCMail(a.RFC);
                              setPaqueteriaMail(a.paqueteria);
                              setAreaMail(a.area);
                              setCodigoClientesMail(a.codigoClientes);
                              setVendedorMail(a.vendedor);
                              setTelefonoMail(a.telefono);
                              setPlazoMail(a.plazo);
                              setNoFactura(a.noFactura);
                              setNoGuia(a.noGuia);
                              toggleEvidencia();
                            }}
                          >
                            <i className="fas fa-file-alt"></i>
                          </Button>
                        ) : (
                          <Button size="sm" color="gris" disabled>
                            <i className="fas fa-file-alt"></i>
                          </Button>
                        )}

                        {a.fotoEvidencia === "Si" && (
                          <Button
                            color="success"
                            className="btn btn-gris"
                            size="sm"
                            onClick={() => jalaFotoEvidencia(a._id)}
                          >
                            <i className="fas fa-camera"></i>
                          </Button>
                        )}

                        <Button
                          size="sm"
                          className="btn"
                          color="danger"
                          onClick={() => cancelarNota(a._id, a.numero)}
                        >
                          <i className="fas fa-ban"></i>
                        </Button>
                        {/* {a.entregada === "No" && (
                          <Button
                            size="sm"
                            className="btn"
                            color="info"
                            onClick={() => entregarNota(a._id, a.numero)}
                          >
                            <i className="fas fa-check"></i>
                          </Button>
                        )} */}

                        {a.saldo > 0 && (
                          <Button
                            size="sm"
                            className="btn"
                            color="primary"
                            onClick={() => {
                              setIdEdit(a._id);
                              setNumeroEdit(a.numero);
                              setClienteEdit(a.clientes);
                              setIdClienteEdit(a.idClientes);
                              setIdColaboradorEdit(a.idVendedor);
                              setMonto(a.saldo)
                              setModalPagarNota(true);
                            }}
                          >
                            <i className="fas fa-dollar-sign"></i>
                          </Button>
                        )}

                        {a.facturado === "No" && (
                          <Button
                            size="sm"
                            className="btn"
                            color="warning"
                            title="Facturar (vista previa)"
                            onClick={() => previewFacturar(a)}
                          >
                            <i className="fas fa-file-invoice-dollar"></i>
                          </Button>
                        )}
                      </>
                    </td>
                  </tr>
                );
              })}

              <tr>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td className="negrita" align="center">
                  TOTAL
                </td>
                <td className="negrita">
                  {new Intl.NumberFormat("en-US", {
                    style: "currency",
                    currency: "USD",
                    maximumFractionDigits: 2,
                  }).format(subTotalImporteTabla)}
                </td>
                <td className="negrita">
                  {new Intl.NumberFormat("en-US", {
                    style: "currency",
                    currency: "USD",
                    maximumFractionDigits: 2,
                  }).format(totalImporteTabla)}
                </td>
                <td></td>
                <td></td>
                <td className="negrita">
                  {new Intl.NumberFormat("en-US", {}).format(totalPiezasTabla)}
                </td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
              </tr>
            </tbody>
          </Table>
          <div className="col-md-6">
            <Pagination
              total={totalItems}
              itemsPerPage={ITEMS_PER_PAGE}
              currentPage={currentPage}
              onPageChange={(page) => setCurrentPage(page)}
            />
          </div>

          <Modal size="lg" isOpen={modalEvidencia} toggle={toggleEvidencia}>
            <ModalHeader toggle={toggleEvidencia}>
              <h4>Evidencias</h4>
            </ModalHeader>
            <ModalBody>
              {impuestosMail == 16 ? (
                <>
                  <Row>
                    <Col md={3}>
                      <Label for="exampleEmail" className="mr-sm-2">
                        # Factura
                      </Label>
                      <Input
                        type="text"
                        placeholder="NoFactura"
                        value={noFactura}
                        required
                        onChange={(e) => {
                          setNoFactura(e.target.value);
                        }}
                      />
                    </Col>
                    <Col md={3}>
                      <Label for="exampleEmail" className="mr-sm-2">
                        # Guia
                      </Label>
                      <Input
                        type="text"
                        placeholder="NoGuia"
                        value={noGuia}
                        required
                        onChange={(e) => {
                          setNoGuia(e.target.value);
                        }}
                      />
                    </Col>
                  </Row>
                </>
              ) : (
                <>
                  <Row>
                    <Col md={3}>
                      <Label for="exampleEmail" className="mr-sm-2">
                        # Guia
                      </Label>
                      <Input
                        type="text"
                        placeholder="NoGuia"
                        value={noGuia}
                        required
                        onChange={(e) => {
                          setNoGuia(e.target.value);
                        }}
                      />
                    </Col>
                  </Row>
                </>
              )}
              <br />
              <Row>
                <Col md={6}>
                  <Label>Evidencia 1</Label>
                  <Input
                    type="file"
                    onChange={(e) => {
                      setFileFotoEvidencia(e.target.files[0]);
                      setFotoEvidencia("No");
                    }}
                  />
                </Col>
              </Row>
              {impuestosMail == 16 ? (
                <>
                  <br />
                  <Row>
                    <Col md={6}>
                      <Label>Evidencia 2</Label>
                      <Input
                        type="file"
                        onChange={(e) => {
                          setFileFotoEvidencia2(e.target.files[0]);
                          setFotoEvidencia2("No");
                        }}
                      />
                    </Col>
                  </Row>
                </>
              ) : undefined}

              <br />
              <Button
                color="success"
                className="btn"
                onClick={(e) => {
                  saveFotoEvidencia();
                }}
                disabled={
                  !(
                    (impuestosMail === 16 &&
                      fileFotoEvidencia &&
                      fotoEvidencia === "No" &&
                      fileFotoEvidencia2 &&
                      fotoEvidencia2 === "No") ||
                    (impuestosMail === 0 &&
                      fileFotoEvidencia &&
                      fotoEvidencia === "No")
                  )
                }
              >
                Subir
              </Button>
            </ModalBody>
            <ModalFooter></ModalFooter>
          </Modal>

          <Modal
            size="xxl"
            isOpen={modalVerFotoEvidencia}
            toggle={toggleVerFotoEvidencia}
          >
            <ModalHeader toggle={toggleVerFotoEvidencia}>
              <h4>Evidencias</h4>
            </ModalHeader>
            <ModalBody>
              <Row>
                {photoEvidencia.length > 0 ? (
                  photoEvidencia.map((a) => {
                    return (
                      <h6 style={{ textAlign: "center" }}>
                        <img src={a.secure_url} width="500" height="auto" />
                      </h6>
                    );
                  })
                ) : (
                  <h4>Espera a que se carguen las fotos</h4>
                )}
              </Row>
            </ModalBody>
          </Modal>

          <Modal size="sm" isOpen={modalEditNota} toggle={toggleEditNota}>
            <ModalHeader toggle={toggleEditNota}>
              <h4>
                Editar Nota {numeroEdit} Cliente {clienteEdit}{" "}
              </h4>
            </ModalHeader>
            <ModalBody>
              <Row>
                <Col md={6}>
                  <Label for="exampleEmail" className="mr-sm-2">
                    Factura
                  </Label>
                  <Input
                    bsSize="sm"
                    type="text"
                    value={facturaEdit}
                    onChange={(e) => {
                      setFacturaEdit(e.target.value);
                    }}
                  />
                </Col>
              </Row>
              <br />
              <br />
              <Button
                size="sm"
                color="success"
                onClick={(e) => saveEditarNota()}
                tabindex="-1"
              >
                Guardar
              </Button>
            </ModalBody>
          </Modal>

          <Modal size="md" isOpen={modalPagarNota} toggle={togglePagarNota}>
            <ModalHeader toggle={togglePagarNota}>
              <h4>
                Pagar Nota {numeroEdit} Cliente {clienteEdit}{" "}
              </h4>
            </ModalHeader>
            <ModalBody>
              <Row>
                <Col md={6}>
                  <Label className="mr-sm-2">Fecha</Label>
                  <Input
                    type="date"
                    value={fecha}
                    required
                    onChange={(e) => {
                      setFecha(e.target.value);
                    }}
                  />
                </Col>
                <Col md={6}>
                  <Label className="mr-sm-2">Concepto</Label>
                  <Input
                    type="select"
                    value={concepto}
                    onChange={(e) => {
                      setConcepto(e.target.value);
                    }}
                  >
                    <option value="">Selecciona un Concepto</option>
                    <option value="Abono">Abono</option>
                    <option value="Bonificacion">Bonificacion</option>
                  </Input>
                </Col>
                </Row>
                <Row>
                <Col md={6}>
                  <Label className="mr-sm-2">Forma de Pago</Label>
                  <Input
                    type="select"
                    value={formaPago}
                    onChange={(e) => {
                      setFormaPago(e.target.value);
                    }}
                  >
                    <option value="">Selecciona una Forma de Pago</option>
                    <option value="Efectivo">Efectivo</option>
                    <option value="Transfer">Transfer</option>
                    <option value="TDC">TDC</option>
                    <option value="TDD">TDD</option>
                    <option value="Link de Pago">Link de Pago</option>
                    <option value="Bonificacion">Bonificacion</option>
                  </Input>
                </Col>
                <Col md={6}>
                  <Label className="mr-sm-2">Banco</Label>
                  <Input
                    type="select"
                    value={selectedBanco}
                    onChange={(e) => {
                      jalaBanco(e.target.value);
                    }}
                  >
                    <option value="">Selecciona un Banco</option>
                    {bancos
                      .sort((a, b) => (a.banco > b.banco ? 1 : -1))
                      .map((a) => {
                        return (
                          <option value={a._id}>
                            {a.banco} {a.cuenta}
                          </option>
                        );
                      })}
                  </Input>
                </Col>
              </Row>
              <br />
              <br />
              <Button
                size="sm"
                color="success"
                onClick={e=>savePagarNota()}
                tabindex="-1"
              >
                Guardar
              </Button>
            </ModalBody>
          </Modal>

                    <Modal size="sm" isOpen={modalProgreso} toggle={toggleProgreso}>
                      <ModalHeader toggle={toggleProgreso}>
                        <h4>Progreso</h4>
                      </ModalHeader>
                      <ModalBody>
                       <h4> Este proceso puede tardar varios segundos.
                        <br />
                        Por favor no cierre ni refresque su navegador.
                        </h4>
                        <br />
                        <div className="progreso">
                            <Spinner
                              style={{
                                width: "50px",
                                height: "50px",
                                color: "#232B41",
                              }}
                            />
                            <Spinner
                              style={{
                                width: "50px",
                                height: "50px",
                                color: "#232B41",
                              }}
                            />
                            <Spinner
                              style={{
                                width: "50px",
                                height: "50px",
                                color: "#232B41",
                              }}
                            />
                        </div>
                      </ModalBody>
                    </Modal>

          <Modal
            size="xl"
            isOpen={modalFacturarPreview}
            toggle={toggleFacturarPreview}
            style={{ maxWidth: "90%", margin: "0 auto" }}
          >
            <ModalHeader toggle={toggleFacturarPreview}>
              Vista previa Factura — Nota {facturarSurtido?.numero}
            </ModalHeader>
            <ModalBody>
              {facturarSurtido && (
                <>
                  <Row>
                    <Col md={6}>
                      <h5>Cliente</h5>
                      <div><b>Nombre:</b> {facturarCliente?.razon_social || facturarSurtido.clientes}</div>
                      <div><b>RFC:</b> {facturarCliente?.RFC || "—"}</div>
                      <div><b>Uso CFDI:</b> {facturarCliente?.usoCFDI || "—"}</div>
                      <div><b>Forma Pago SAT:</b> {facturarCliente?.formaPagoSAT || "—"}</div>
                      <div><b>Método Pago SAT:</b> {facturarCliente?.metodoPagoSAT || "—"}</div>
                      <div><b>Condiciones Pago:</b> {facturarCliente?.condicionesPagoSAT || "—"}</div>
                      <div><b>Régimen Fiscal:</b> {facturarCliente?.regFiscal || "—"}</div>
                      <div><b>CP:</b> {facturarCliente?.cp || "—"}</div>
                    </Col>
                    <Col md={6}>
                      <h5>Empresa Emisora</h5>
                      <div><b>Nombre:</b> {facturarEmpresa?.razonSocial || facturarSurtido.empresas}</div>
                      <div><b>RFC:</b> {facturarEmpresa?.rfc || "—"}</div>
                      <div><b>Régimen Fiscal:</b> {facturarEmpresa?.regimenFiscal || "—"}</div>
                      <div><b>CP:</b> {facturarEmpresa?.cp || "—"}</div>
                      <br />
                      <Row>
                        <Col md={6}>
                          <Label>Serie</Label>
                          <Input
                            bsSize="sm"
                            type="select"
                            value={facturarSerie}
                            onChange={(e) => setFacturarSerie(e.target.value)}
                          >
                            <option value="">Selecciona</option>
                            {facturarSeries.map((s) => (
                              <option key={s._id || s.serie} value={s.serie}>
                                {s.serie}
                              </option>
                            ))}
                          </Input>
                        </Col>
                        <Col md={6}>
                          <Label>Timbres disponibles</Label>
                          <div>
                            <b>{facturarTimbres}</b>
                          </div>
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                  <hr />
                  <h5>Artículos</h5>
                  <Table size="sm" striped>
                    <thead>
                      <tr>
                        <th>Código</th>
                        <th>Descripción</th>
                        <th align="right">Cantidad</th>
                        <th align="right">Precio</th>
                        <th align="right">Importe</th>
                      </tr>
                    </thead>
                    <tbody>
                      {facturarArticulos.map((art) => (
                        <tr key={art._id}>
                          <td>{art.articulos?.[0]?.codigo || ""}</td>
                          <td>{art.articulos?.[0]?.nombre || art.articulos?.[0]?.codigoCliente || ""}</td>
                          <td align="right">{art.cantidad}</td>
                          <td align="right">
                            {new Intl.NumberFormat("en-US", {
                              style: "currency",
                              currency: "USD",
                              maximumFractionDigits: 2,
                            }).format(art.precio || 0)}
                          </td>
                          <td align="right">
                            {new Intl.NumberFormat("en-US", {
                              style: "currency",
                              currency: "USD",
                              maximumFractionDigits: 2,
                            }).format(art.total || (art.cantidad * (art.precio || 0)))}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </Table>
                  <Row className="mt-3">
                    <Col md={{ size: 4, offset: 8 }}>
                      <Table size="sm" borderless>
                        <tbody>
                          <tr>
                            <td><b>SubTotal</b></td>
                            <td align="right">
                              {new Intl.NumberFormat("en-US", {
                                style: "currency",
                                currency: "USD",
                                maximumFractionDigits: 2,
                              }).format(facturarSurtido.subTotal || 0)}
                            </td>
                          </tr>
                          <tr>
                            <td><b>IVA</b></td>
                            <td align="right">
                              {new Intl.NumberFormat("en-US", {
                                style: "currency",
                                currency: "USD",
                                maximumFractionDigits: 2,
                              }).format(facturarSurtido.iva || 0)}
                            </td>
                          </tr>
                          <tr>
                            <td><b>Total</b></td>
                            <td align="right">
                              <b>
                                {new Intl.NumberFormat("en-US", {
                                  style: "currency",
                                  currency: "USD",
                                  maximumFractionDigits: 2,
                                }).format(facturarSurtido.total_general || 0)}
                              </b>
                            </td>
                          </tr>
                        </tbody>
                      </Table>
                    </Col>
                  </Row>
                </>
              )}
            </ModalBody>
            <ModalFooter>
              <Button color="secondary" onClick={toggleFacturarPreview} disabled={facturando}>
                Cancelar
              </Button>
              <Button color="success" onClick={confirmarFacturar} disabled={facturando}>
                {facturando ? "Timbrando..." : "Confirmar y Timbrar"}
              </Button>
            </ModalFooter>
          </Modal>

        </div>
      ) : undefined}
      <br />
      {loader}
    </>
  );
}

export default ListadoVentas;
